<template>
  <div>
    <!-- <h3>
      {{ errorMessage }}
    </h3>-->

    <section class="container-fluid p-0 bodyArea">
      <div class="containerBox">
        <div class="pageHeader row align-items-center" v-if="$auth.isAuthenticated">
          <div class="col-3 pageHeaderTitle">Users</div>
          <div class="col text-right">
            <div class="filterWrapper">
              <div class="filterText">Tenant :</div>
              <div class="dropdown col p-0">

                <model-select v-model="lastSelectedTenantObj" :options="tenants" name="text" id="value"
                              placeholder="Select Tenant" @input="validateSelection">
                </model-select>
                <!-- <select
                  style="background: transparent; color: #fff; border: 0"
                  id="tenantId"
                  v-model="lastSelectedTenant"
                  @change="changeTenantView"
                >
                  <option
                    class="tenantOption"
                    v-for="option in tenants"
                    :key="option"
                    :value="option.value"
                  >
                    {{ option.text ? option.text : option.value }}
                  </option>
                </select> -->
              </div>
            </div>

            <!-- <input
              type="file"
              style="display:none"
              id="fileInput"
              @change="handleFiles"
              accept=".csv"
            />-->

            <!--  <div class="filterWrapper filter-wrapper-2"> -->
            <!-- <div class="dropdown col p-0"> -->

            <!-- <input v-model="filterString" type="text" maxlength="20" class="filterInputText" /> -->
            <!-- <select
                style="background: transparent; color: #fff;  border: 0;"
                id="tenantConnectionId"
                v-model="currentSelectedConnectionId"
              >
                <option value="-Select Authentication Mechanism-" selected
                  >-Select Authentication Mechanism-</option
                >
                <option
                  class="tenantOption"
                  v-for="connection in currentTenantsConnectionIds"
                  v-bind:key="connection"
                  :value="connection"
                >
                  {{ connection }}
                </option>
            </select>-->
            <!-- </div> -->
            <!-- </div> -->
            <!--   <button @click.prevent="showImportScreen" style="margin-left:20px;" v-if="(selectedUsers == null || selectedUsers.length === 0) && !isImportingUserOperation">Import</button> -->
            <div class="importBtn" @click.prevent="showImportScreen" :hidden="lastSelectedTenant == ''" v-if="(selectedUsers == null || selectedUsers.length === 0) &&
              !isImportingUserOperation
              ">
              Import
            </div>
            <div class="filterWrapper filter-wrapper-2">
              <div class="filterText pad-10">Filter:</div>
              <!-- <div class="dropdown col p-0"> -->

              <input v-model="filterString" type="text" maxlength="20" class="filterInputText"
                     @keyup="getUsersList($event)" />
              <!-- <select
                  style="background: transparent; color: #fff;  border: 0;"
                  id="tenantConnectionId"
                  v-model="currentSelectedConnectionId"
                >
                  <option value="-Select Authentication Mechanism-" selected
                    >-Select Authentication Mechanism-</option
                  >
                  <option
                    class="tenantOption"
                    v-for="connection in currentTenantsConnectionIds"
                    v-bind:key="connection"
                    :value="connection"
                  >
                    {{ connection }}
                  </option>
              </select>-->
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div v-if="usersListEmpty" >
           <h3 class="contentInfo">No results found</h3>
         </div>
        <div class="pageDataWrapper"  v-if="users &&
          users.length > 0 &&
          (selectedUsers == null || selectedUsers.length === 0) &&
          !isImportingUserOperation
          " >
          <div class="contentHeader row m-0 align-items-center">
            <div class="col-4">Name</div>
            <div class="col-2">Contacts</div>
            <!-- <div class="col-2">Assignments</div> -->
            <div class="col hasNotifications text-center">
              Has Notifications
            </div>

            <div class="col hasNotifications text-center">Action</div>
            <div class="col-2 row text-center">
              <div v-if="inviteUsers.length <= 0">Select</div>
              <!-- <div 
                v-if="selectedUsersMail != null && selectedUsersMail.length > 0"
                class="buttonItem row"
                style="border:0px"
                @click.prevent="sendMailUsers"
              >Send</div>-->
              <button v-if="inviteUsers && inviteUsers.length > 0" class="buttonItem"
                      style="border: 0px; margin-left: 0px; padding: 5px 14px" @click.prevent="sendInviteToSelectedUsers">
                Send Invitation
              </button>
            </div>
          </div>
          
          <div class="contentDataWrapper userContentWrapper row m-0">
            <div class="contentData row m-0 align-items-center col-12 p-0" v-for="user in users" :key="user._id">
              <div class="col-4 row m-0">
                <div class="col p-0">
                  <span class="smallFont" style="font-weight: bold">
                    {{ user.name ? (user.name.first || "") + " " + (user.name.last || "") : "Not On File" }}
                  </span>
                  <span class="smallFont userId">{{ user.userId }}</span>
                </div>
                <!-- <div class="col p-0">Consulate | PD 5311</div> -->
              </div>
              <div class="col-2 row m-0">
                <div class="col p-0 contacts">
                  <span class="smallFont">
                    {{
                      user.email ||
                      (user.userId && user.userId.indexOf("@") > 0
                        ? user.userId.split("|")[1]
                        : "Not On File")
                    }}
                    {{ +" - " + user.phone ? user.phone : "" }}
                  </span>
                </div>
                <!-- <div class="col p-0 text-right">
                  <span>Phone :</span>(407)-564-6739345
                </div>-->
              </div>
              <!-- <div class="col-2" v-html="user.assignedLocationInfo"></div> -->
              <div class="col hasNotifications text-center">
                {{ user.subscribedToNotifications.toString().toUpperCase() }}
                <!-- <br />
                <span class="smallFont" style="color:red">{{
                  user.subscribedToNotifications &&
                  (!user.phone || user.phone.length === 0) &&
                  (!user.sessions || user.sessions.length === 0)
                    ? "NO alert channel!"
                    : ""
                }}</span
                ><br />
                <span class="smallFont" style="color:red">{{
                  user.subscribedToNotifications &&
                  showAssignedNotifications(user).length === 0
                    ? "INVALID alert config!"
                    : ""
                }}</span>-->
              </div>

              <div class="col hasNotifications text-center">
                <button class="buttonItem m-0" v-if="user.userId && user.userId.indexOf('google-apps|') < 0"
                        @click="(showModal = true), (deletedUser = user.userId)">
                  Delete
                </button>
              </div>
              <div class="col-2 row m-0">
                <label class="checkbox-container col-4" v-if="(user.userId && user.userId.indexOf('auth0|') >= 0) ||
                  lastSelectedTenant === 'tcv' ||
                  lastSelectedTenant === 'qhc'
                  ">
                  Send Invite
                  <input type="checkbox" :key="user._id" :value="user.userId" v-model="inviteUsers" />
                  <span class="checkmark"></span>
                </label>
                <!-- <span class="smallFont" v-if="(user.userId && user.userId.indexOf('auth0|')>=0 ) || lastSelectedTenant === 'tcv' || lastSelectedTenant === 'qhc'">
                <input type="checkbox" v-bind:key="user" :value="user.userId" v-model="inviteUsers">Send Invite</span>-->
              </div>
              <!-- Modal Content  -->
            </div>
          </div>
        </div>
        <!-- <div class="pageDataWrapper" v-if="isImportingUserOperation">
        <div class="userDetailContentHeader row m-0 align-items-center">
        <div class="col justify-content-end">
         <div class="filterWrapper filter-wrapper-2">
           <select
                style="background: transparent; color: #fff;  border: 0;"
                id="tenantConnectionId"
                v-model="currentSelectedConnectionId"
              >
                <option value="-Select Authentication Mechanism-" selected
                  >-Select Authentication Mechanism-</option
                >
                <option
                  class="tenantOption"
                  v-for="connection in currentTenantsConnectionIds"
                  v-bind:key="connection"
                  :value="connection"
                >
                  {{ connection }}
                </option>
              </select> 
              <input  type="file" id="csvFileInput" @change="handleFiles" accept=".csv">
         </div>
         <div
            class="buttonItem"
            @click.prevent="closeImportScreen" id="closeImportScreenBTN"            
          >
            Close<img src="../assets/images/closeIcon.svg" width="14" />
          </div>            
        </div>
       </div>
        </div>-->

        <div class="pageDataWrapper" v-if="isImportingUserOperation">
          <div class="userDetailContentHeader row m-0 align-items-center">
            <div class="col justify-content-end align-items-center">
              <div style="align-self: center">
                CSV file must have [Facility, Location, Sensor Name, First Name,
                Last Name, Email, User Type, Alert Status, SMS
                {{
                  currentSelectedConnectionId &&
                  currentSelectedConnectionId
                    .toLowerCase()
                    .indexOf("consulate") >= 0
                    ? ",Employee Id"
                    : ""
                }}]
              </div>
              <div class="filterWrapper filter-wrapper-2">
                <select style="background: transparent; color: #fff; border: 0" id="tenantConnectionId"
                        v-model="currentSelectedConnectionId" :disabled="importedUsers && importedUsers.length > 0">
                  <option value="-Select Authentication Mechanism-" selected>
                    -Select Authentication Mechanism-
                  </option>
                  <option class="tenantOption" v-for="connection in currentTenantsConnectionIds"
                          v-bind:key="connection._id" :value="connection">
                    {{ connection }}
                  </option>
                </select>
              </div>
              <input type="file" hidden style="display: none" id="fileInput" @change="handleFiles" accept=".csv" />
              <div class="buttonItem" style="margin-left: 10px!important" v-if="lastSelectedTenant &&
                lastSelectedTenant.length > 0 &&
                currentSelectedConnectionId != null &&
                currentSelectedConnectionId.length > 0 &&
                (!importedUsers || importedUsers.length == 0)
                " type="file" id="csvFileInput" @click.prevent="showFileImportScreen" accept=".csv" :hidden="currentSelectedConnectionId =='-Select Authentication Mechanism-'">
                Browse
              </div>
              <div class="buttonItem" style="margin-left: 10px!important" @click.prevent="closeImportScreen"
                   id="closeImportScreenBTN">
                Close
                <!--  <img src="../assets/images/closeIcon.svg" width="14" /> -->
              </div>
            </div>
          </div>
          <div v-if="importedUsers && importedUsers.length > 0"
               class="userDetailContentHeader row m-0 align-items-center">
            <div class="col justify-content-end">
              <div class="subHeadWrap">{{ importLoadingMessage }}</div>
              <div class="buttonItem" @click.prevent="beginImportUser" id="importUserBTN">
                Start Importing
                <img src="../assets/images/configuration-icon.svg" width="14" />
              </div>
              <div class="subHeadWrap">
                Total Users: {{ importedUsers.length }} &nbsp;
                <span class="smallFont" style="font-weight: bolder; color: #fe490f">
                  {{
                    importedUsers.find((x) => !x.isValid) != null
                      ? " => Found Errors! Please check the list."
                      : ""
                  }}
                </span>
              </div>

              <div class="subHeadWrap">Send Welcome For New Users?</div>
              <div class="selectListItems1">
                <select class="form-control" id="shouldSendWelcomeEmailOnImport">
                  <option v-for="option in sendMail" v-bind:key="option.value" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <!-- <div
            class="buttonItem"
            @click.prevent="closeImportScreen" id="closeImportScreenBTN"            
          >
            Close<img src="../assets/images/closeIcon.svg" width="14" />
              </div>-->

              <!-- <div class="buttonItem" @click.prevent="saveUser()" id="saveUserBtn">
            Save<img src="../assets/images/saveIcon.svg" width="14" />
              </div>-->
            </div>
          </div>
          <div class="row" style="height: 10px"></div>
          <div v-if="importedUsers != null && importedUsers.length > 0">
            <!-- <p class="smallFont isProcessing">{{importLoadingMessage}}</p> -->
            <table width="100%">
              <!-- <tr>
            <td>
              <select id="tenantConnectionId" v-model="currentSelectedConnectionId">
                <option value="">-Select Authentication Mechanism-</option>
                <option v-for="connection in currentTenantsConnectionIds"
                  v-bind:key="connection"
                  :value="connection">
                  {{ connection }}
                </option>
              </select>
            </td>
            <td>
              <button @click.prevent="closeImportScreen" id="closeImportScreenBTN">Close</button>
            </td>
          </tr>
          <tr v-if="lastSelectedTenant && lastSelectedTenant.length > 0 && currentSelectedConnectionId != null && currentSelectedConnectionId.length > 0 && (!importedUsers || importedUsers.length == 0)" >
            <td>
              Select CSV File to Import: 
            </td>
            <td>
              <input type="file" id="csvFileInput" @change="handleFiles" accept=".csv">
            </td>
          </tr>
          <tr>
            <td colspan="2" style="background-color:#1a8ac2">
              <span class="smallFont" style="color:#fff">CSV file must have [Facility, Location, Sensor Name, First Name, Last Name, Email, User Type, Alert Status, SMS {{currentSelectedConnectionId && currentSelectedConnectionId.toLowerCase().indexOf('consulate')>=0?",Employee Id":""}}]</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              
            </td>
          </tr> 
          <tr v-if="importedUsers && importedUsers.length > 0">
            <td>
              <button @click.prevent="beginImportUser" id="importUserBTN">Start Importing</button>&nbsp;Total Users: {{importedUsers.length}}  &nbsp;<span class="smallFont" style="font-weight:bolder;color:#fe490f" >{{importedUsers.find(x => !x.isValid)!= null?' => Found Errors! Please check the list.':''}}</span>
            </td>
            <td>
              Send Welcome For New Users? &nbsp;
              <select id="shouldSendWelcomeEmailOnImport">
                <option value="false" selected>False</option>
                <option value="true">True</option>
              </select>
            </td>
              </tr>-->
              <tr v-if="importLoadingMessage && importLoadingMessage.length > 0
                ">
                <td colspan="2" style="background-color: #1a8ac2">
                  <span class="smallFont" style="color: #fff">
                    {{ importLoadingMessage }}
                  </span>
                </td>
              </tr>
              <tr v-if="importedUsers != null && importedUsers.length > 0">
                <td colspan="2">
                  <table width="100%" class="tableDataWrapper">
                    <tr class="contentHeader align-items-center">
                      <td>Line Number</td>
                      <td>User Id</td>
                      <td>Name</td>
                      <td>Email</td>
                      <td v-if="['tcv-auth-db', 'tgh-auth-db'].includes(
                        currentSelectedConnectionId
                      )
                        ">
                        Username
                      </td>
                      <td>Facility</td>
                      <td>Mobile</td>
                      <td>Alert Status</td>
                      <td>Role</td>
                      <td>Action</td>
                    </tr>
                    <tr :class="importedUser.isValid ? 'contentRow' : 'contentRow error'
                      " v-for="importedUser in importedUsers" v-bind:key="importedUser.lineNumber">
                      <td v-bind:key="importedUser.lineNumber">
                        {{ importedUser.lineNumber }} &nbsp;
                        <button v-if="!importedUser.isValid" class="buttonItem" style="border: 0px" @click.prevent="
                          showValidationError(importedUser.lineNumber)
                          ">
                          error
                        </button>
                        <svg v-bind:id="importedUser.lineNumber + '_processing'" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: 0px; display: none" width="38px"
                             height="38px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                          <path fill="none" stroke="#1d3f72" stroke-width="8"
                                stroke-dasharray="42.76482137044271 42.76482137044271"
                                d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                                stroke-linecap="round" style="
                              transform: scale(0.8);
                              transform-origin: 50px 50px;
                            ">
                            <animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="0.5988023952095808s"
                                     keyTimes="0;1" values="0;256.58892822265625" />
                          </path>
                        </svg>
                        <svg v-bind:id="importedUser.lineNumber + '_errored'" xml:space="preserve" viewBox="0 0 100 100"
                             y="0" x="0" xmlns="http://www.w3.org/2000/svg" version="1.1" style="
                            display: none;
                            margin: 0px;
                            background: rgb(255, 255, 255);
                          " width="38px" height="38px">
                          <g class="ldl-scale" style="
                              transform-origin: 50% 50%;
                              transform: rotate(0deg) scale(0.8, 0.8);
                            ">
                            <g class="ldl-ani">
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -0.694444s infinite
                                      normal forwards running breath-ab9391a7-2963-4b58-8277-f7810de88660;
                                  ">
                                  <path d="M23.364 9.625h61.875v43.384H23.364z" stroke-miterlimit="10"
                                        stroke-linejoin="round" stroke-width="3.5" stroke="#323232" fill="#d65a62" style="
                                      fill: rgb(214, 90, 98);
                                      stroke: rgb(50, 50, 50);
                                    " />
                                </g>
                              </g>
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -0.833333s infinite
                                      normal forwards running breath-ab9391a7-2963-4b58-8277-f7810de88660;
                                  ">
                                  <path d="M14.761 7h8.603v86h-8.603z" stroke-linejoin="round" stroke="#323232"
                                        fill="#f4e6c8" stroke-miterlimit="10" stroke-width="3.5" style="
                                      fill: rgb(244, 230, 200);
                                      stroke: rgb(50, 50, 50);
                                    " />
                                </g>
                              </g>
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -0.972222s infinite
                                      normal forwards running breath-ab9391a7-2963-4b58-8277-f7810de88660;
                                  ">
                                  <path d="M42.489 42.491l23-23" stroke-miterlimit="10" stroke-width="6" stroke="#fff"
                                        fill="none" style="stroke: rgb(255, 255, 255)" />
                                </g>
                              </g>
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -1.11111s infinite
                                      normal forwards running breath-ab9391a7-2963-4b58-8277-f7810de88660;
                                  ">
                                  <path d="M65.489 42.491l-23-23" stroke-miterlimit="10" stroke-width="6" stroke="#fff"
                                        fill="none" style="stroke: rgb(255, 255, 255)" />
                                </g>
                              </g>
                              <metadata xmlns:d="care.ai/">
                                <d:name>fail</d:name>
                                <d:tags>fail,reject,deny,negative,refuse,error,cancel,drop,warning,flag,signal</d:tags>
                                <d:license>by</d:license>
                                <d:slug>9mvy1p</d:slug>
                              </metadata>
                            </g>
                          </g>
                        </svg>
                        <svg v-bind:id="importedUser.lineNumber + '_done'" xml:space="preserve" viewBox="0 0 100 100"
                             y="0" x="0" xmlns="http://www.w3.org/2000/svg" version="1.1"
                             style="display: none; background: rgb(255, 255, 255)" width="40px" height="40px">
                          <g class="ldl-scale" style="
                              transform-origin: 50% 50%;
                              transform: rotate(0deg) scale(0.8, 0.8);
                            ">
                            <g class="ldl-ani">
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -0.740741s infinite
                                      normal forwards running breath-eefdce62-1fe7-4610-8ee7-497992e22e78;
                                  ">
                                  <path d="M23.364 9.625h61.875v43.384H23.364z" stroke-miterlimit="10" stroke-width="3.5"
                                        stroke="#323232" fill="#acbd81" stroke-linejoin="round" style="
                                      fill: rgb(172, 189, 129);
                                      stroke: rgb(50, 50, 50);
                                    " />
                                </g>
                              </g>
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -0.925926s infinite
                                      normal forwards running breath-eefdce62-1fe7-4610-8ee7-497992e22e78;
                                  ">
                                  <path d="M39.989 28.027l10.982 10.982 17.018-17.018" stroke-miterlimit="10"
                                        stroke-width="6" stroke="#fff" fill="none" style="stroke: rgb(255, 255, 255)" />
                                </g>
                              </g>
                              <g class="ldl-layer">
                                <g class="ldl-ani" style="
                                    transform: scale(0.91);
                                    transform-origin: 50px 50px;
                                    animation: 1.11111s linear -1.11111s infinite
                                      normal forwards running breath-eefdce62-1fe7-4610-8ee7-497992e22e78;
                                  ">
                                  <path d="M14.761 7h8.603v86h-8.603z" stroke-linejoin="round" stroke="#323232"
                                        fill="#f4e6c8" stroke-miterlimit="10" stroke-width="3.5" style="
                                      fill: rgb(244, 230, 200);
                                      stroke: rgb(50, 50, 50);
                                    " />
                                </g>
                              </g>
                              <metadata xmlns:d="https://care.ai/stock/">
                                <d:name>okay</d:name>
                                <d:tags>okay,done,finish,right,confirm,complete,pass,correct,success</d:tags>
                                <d:license>by</d:license>
                                <d:slug>5i0q2q</d:slug>
                              </metadata>
                            </g>
                          </g>
                        </svg>
                        <br />
                      </td>

                      <td>{{ importedUser["User Id"] }}</td>
                      <td>{{ importedUser["Name"] }}</td>
                      <td>{{ importedUser["Email"] }}</td>
                      <td v-if="['tcv-auth-db', 'tgh-auth-db'].includes(
                        currentSelectedConnectionId
                      )
                        ">
                        {{ importedUser["Username"] }}
                      </td>
                      <td>
                        {{ importedUser.Facility }}/{{
                          importedUser.Location
                        }}/{{ importedUser["Sensor Name"] }}
                      </td>
                      <td>{{ importedUser["SMS"] }}</td>
                      <td>{{ importedUser["Alert Status"] }}</td>
                      <td>{{ importedUser["Role"] }}</td>
                      <td>
                        <button v-bind:id="importedUser.lineNumber + '_runAgainBTN'" class="buttonItem"
                                style="border: 0px" @click.prevent="tryUserAgain(importedUser.lineNumber)">
                          Try Again
                        </button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="pageDataWrapper1" v-if="selectedUsers != null &&
          selectedUsers.length === 1 &&
          getSelectedUser() != null
          ">
          <div class="userDetailContentHeader row m-0 align-items-center">
            <div class="col-3">
              <img src="../assets/images/userDetailIcon.svg" width="18" />&nbsp;&nbsp;
              <br />
              <span class="smallFont">
                {{
                  currentSelectedUser.name
                    ? currentSelectedUser.name.first +
                    " " +
                    currentSelectedUser.name.last
                    : ""
                }}
              </span>
            </div>
            <div class="col text-right row m-0 justify-content-end">
              <div class="buttonItem" @click.prevent="clearUser()" id="sendWelcomeBTN">
                Close
                <img src="../assets/images/closeIcon.svg" width="14" />
              </div>
              <div class="buttonItem" @click.prevent="showModal1 = true" id="sendWelcomeBTN">
                Send Welcome Email
                <img src="../assets/images/mailIcon.svg" width="14" />
              </div>
              <div class="buttonItem" @click.prevent="unblockUser()" disabled="true">
                Unblock
                <img src="../assets/images/unblockIcon.svg" width="14" />
              </div>
              <div class="buttonItem" @click.prevent="resetPassword()" id="resetPasswordBTN">
                Reset Password
                <img src="../assets/images/passwordIcon.svg" width="14" />
              </div>
              <div class="buttonItem" @click.prevent="saveUser()" id="saveUserBtn">
                Save
                <img src="../assets/images/saveIcon.svg" width="14" />
              </div>
            </div>
          </div>
          <div v-if="selectedUsers != null &&
            selectedUsers.length === 1 &&
            getSelectedUser() != null
            " class="contentDataWrapper detailWrapper row m-0 align-items-center justify-content-center">
            <div class="col-8 row m-0">
              <div class="row m-0 userDemograpics p-0">
                <div class="col pl-0">
                  <div class="labelText">First Name</div>
                  <input type="text" id="userfirstName" v-bind:key="currentSelectedUser" :value="currentSelectedUser.name
                    ? currentSelectedUser.name.first
                    : ''
                    " />
                </div>
                <div class="col">
                  <div class="labelText">Last Name</div>
                  <input type="text" id="userlastName" v-bind:key="currentSelectedUser" :value="currentSelectedUser.name
                    ? currentSelectedUser.name.last
                    : ''
                    " />
                </div>
                <div class="col pr-0">
                  <div class="labelText">Phone</div>
                  <input type="text" id="userPhone" v-bind:key="currentSelectedUser" :value="currentSelectedUser.phone" />
                </div>
              </div>
              <div class="row m-0 userDetails p-0">
                <div class="col pl-0">
                  <div class="labelText">Add Locations</div>
                  <div class="row m-0">
                    <div class="selectListItems">
                      <select class="form-control" id="assignLocationSB">
                        <option v-for="option in locationList" v-bind:key="option.locationId"
                                v-bind:value="JSON.stringify(option.value)">
                          {{ option.text }}
                        </option>
                      </select>
                    </div>
                    <div class="addBtn" @click.prevent="assignLocationToUser">
                      + Add
                    </div>
                    <div>
                      <p v-html="currentSelectedUser.assignedLocation"></p>
                    </div>
                    <!-- <div>
                      <div
                        v-for="(tempLocationObject,index) in locationList"
                        v-bind:key="tempLocationObject"
                        class="row m-0"
                        v-if="getLocationIndex(tempLocationObject,currentSelectedUser)"
                        style="font-size: 9px;"
                      >
                        <div class="col">{{tempLocationObject.text}} - {{getLocationIndex(tempLocationObject,currentSelectedUser)}}</div>
                        <div class="col-2 actionHeading text-center">
                          <img
                            v-on:click="removeLocation(currentSelectedUser.locations.indexOf(tempLocationObject.value.lid))"
                            src="../assets/images/remove.svg"
                            width="16"
                          />
                        </div>
                      </div>
                     
                    </div>-->
                  </div>
                  <!-- <div class="row m-0" v-for="(item,index) in currentSelectedUser.locationList" v-bind:key="item">
                    <div class="col"> 
                     {{showAssignedLocations(item)}}                     
                    </div>      
                    <div class="col-2 actionHeading text-center">
                    <img 
                     v-on:click="removeLocation(index)"           
                     src="../assets/images/remove.svg"
                    width="16"
                    />
                    </div>                   
                  </div>-->
                  <div class="row m-0 clearSelectedItems" @click.prevent="clearUserLocation">
                    Clear All
                  </div>
                </div>
                <div class="col pr-0">
                  <div class="labelText">Assigned Notifications</div>
                  <div class="row m-0">
                    <div class="selectListItems">
                      <select class="form-control" id="assignNotificationSB">
                        <option v-for="option in locationNotifyList" v-bind:key="option.value"
                                v-bind:value="JSON.stringify(option.value)">
                          {{ option.text }}
                        </option>
                      </select>
                    </div>
                    <div class="addBtn" @click.prevent="assignNotificationToUser">
                      + Add
                    </div>
                  </div>
                  <div class="row m-0" v-for="(item, index) in currentSelectedUser.notifications" v-bind:key="index">
                    <div class="col">
                      {{ showAssignedLocationNotifications(item) }}
                    </div>
                    <div class="col-2 actionHeading text-center">
                      <img v-on:click="removeLocationNotification(index)" src="../assets/images/remove.svg" width="16" />
                    </div>
                  </div>
                  <div class="row m-0 clearSelectedItems" @click.prevent="clearNotifications">
                    Clear All
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="showModal == true">
      <div class="areYouSureWrapper row m-0 align-items-center">
        <div class="popUpContent">
          <div class="popupHead">
            <span aria-hidden="true" @click="showModal = false">&times;</span>
          </div>
          <div class="popupBody">Are you sure you want to delete?</div>
          <div class="popupFooter">
            <div class="yesBtn btn" @click.prevent="deleteUser($event), (showModal = false)">
              Yes
            </div>
            <div class="noBtn btn" @click="showModal = false">No</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal1 == true">
      <div class="areYouSureWrapper row m-0 align-items-center">
        <div class="popUpContent">
          <div class="popupHead">
            <span aria-hidden="true" @click="showModal1 = false">&times;</span>
          </div>
          <div class="popupBody">Are you sure you want to send an email?</div>
          <div class="popupFooter">
            <div class="yesBtn btn" @click.prevent="sendWelcomeEmail(), (showModal1 = false)">
              Yes
            </div>
            <div class="noBtn btn" @click="showModal1 = false">No</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
let loader={}
Vue.use(VueToast);
export default {
  name: "Users",
  components: { ModelSelect },
  data() {
    return {
      users: [],
      roles: [],
      usersBackUp: [],
      selectedTenantName: "",
      selectedFilter: "",
      loading: true,
      counts: 0,
      next: "",
      deletedUser: "",
      errorMessage: "Loading...",
      tenants: [],
      tenantsList: [],
      userList: [],
      // nextUsersPointer: [],
      nextUserPointer: [],
      lastSelectedTenant: "",
      lastSelectedTenantObj: "",
      locationList: [],
      locationListBkp: [],
      sendMail: [
        { text: "False", value: "false" },
        { text: "True", value: "true" }
      ],
      userMessage: "",
      locationFilter: null,
      selectedUsers: [],
      selectedUsersMail: [],
      selectedUserAction: "",
      currentSelectedUser: null,
      isImportingUserOperation: false,
      importLoadingMessage: "",
      currentTenantsConnectionIds: [],
      currentSelectedConnectionId: "-Select Authentication Mechanism-",
      importedUsers: null,
      inviteUsers: [],
      showModal: false,
      showModal1: false,
      filterString: "",
      nextUsersPointer: null,
      usersListEmpty:false
      //   otherUser: null
    };
  },
  async created() {
    setTimeout(
      function() {
        this.fetchData();
      }.bind(this),
      1000
    );
  },
  methods: {
    getLocationsTemp(currentUser) {
      return "current user object";
    },
    clearInvitedUsers() {
      this.inviteUsers = [];
    },
    sendMailUsers() {
      //debugger;

      if (this.selectedUsersMail.length) {
        this.selectedUsersMail.forEach((e) => {
          if (e) {
            this.sendWelcomeEmailToUser(e);
          }
        });
      }
    },
    async sendInviteToSelectedUsers() {
      // debugger;
      showGlobalOverlay("Sending Invite.... ");
      var failedUsers = [];
      if (this.inviteUsers && this.inviteUsers.length > 0) {
        var userId = this.inviteUsers.shift();
        var den = this.inviteUsers.length;
        var num = 0;
        while (userId) {
          try {
            var result = await this.sendWelcomeEmailToUser(userId);

            if (!result) {
              failedUsers.push(userId);
            }
          } catch (ex) {
            failedUsers.push(userId);
          }
          num += 1;
          if (den == 0) {
            showGlobalOverlay(`Sending Invite.... 100%`);
          } else {
            showGlobalOverlay(
              `Sending Invite.... ${parseInt((num * 100) / den)}%`
            );
          }

          userId = this.inviteUsers.shift();
        }
      }
      if (failedUsers && failedUsers.length > 0) {
        this.inviteUsers = failedUsers;
        // alert(
        //   "We were not able to send welcome email to some of the users. They are left checked, please review and try again."
        // );
        Vue.$toast.open({
          message:
            "We were not able to send welcome email to some of the users. They are left checked, please review and try again.",
          type: "info"
        });
      }
      hideGlobalOverlay();
    },
    getUsersList(event) {
      var fl = this.usersBackUp;
      if (this.users && this.filterString && this.filterString.length > 0) {
        fl = this.usersBackUp.filter(
          (u) =>
            (u.email &&
              u.email.toLowerCase().indexOf(this.filterString.toLowerCase()) >=
              0) ||
            (u.name &&
              u.name.first &&
              u.name.first
                .toLowerCase()
                .indexOf(this.filterString.toLowerCase()) >= 0) ||
            (u.name &&
              u.name.last &&
              u.name.last
                .toLowerCase()
                .indexOf(this.filterString.toLowerCase()) >= 0) ||
            (u.userId &&
              u.userId.toLowerCase().indexOf(this.filterString.toLowerCase()) >=
              0)
        );
      }
      this.users = fl;
    },
    getInviteUsers() {
      if (this.inviteUsers && this.inviteUsers.length > 0) {
        return this.inviteUsers
          .map(
            (x) =>
              "<span class=\"smallFont\" style=\"display:block\">" +
              this.users.find((u) => u.userId === x).email +
              "</span>"
          )
          .join("");
      }
      return "none";
    },
    async sendWelcomeEmail() {
      if (this.currentSelectedUser) {
        document.getElementById("sendWelcomeBTN").disabled = true;
        var result = await this.sendWelcomeEmailToUser(
          this.currentSelectedUser.userId
        );
        if (result == true) {
          Vue.$toast.open({
            message: "Sent welcome email to user",
            type: "success"
          });
        }
        if (result == false) {
          Vue.$toast.open({
            message:
              "Failed to send welcome email to user. Please try again later.",
            type: "error"
          });
        }
        document.getElementById("sendWelcomeBTN").disabled = false;
      }
    },
    async sendWelcomeEmailToUser(userId) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      /*  if (userId && userId.indexOf("auth0|") < 0) {
        if (this.lastSelectedTenant != "tcv") {
          Vue.$toast.open({
            message: "Sorry cannot send welcome email for user",
            type: "error"
          });
          return false;
        }
      } */

      var locUrl =
        config.IDENTITY_MANGER +
        `/tenants/${this.lastSelectedTenant}/identities/staff/${userId}/send-welcome`;
      var tenants_list_request = new Request(locUrl, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({}),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          return false;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          return false;
        }
        if (tenantListResponse.status == 503) {
          (this.errorMessage =
            "Error occurred while reseting password for  user: "),
            tenantListResponse.status;
          return false;
        } else if (tenantListResponse.status != 200) {
          return false;
        } else {
       Vue.$toast.open({
              message: "Successfully Sent Inivitation",
              type: "success",
            });
          return true;
        }
      } catch (tex) {
        Vue.$toast.open({
          message: "Failed to send welcome email due to an error",
          type: "error"
        });
        return false;
      }
    },
    async showValidationError(lineNumber) {
      var u = this.importedUsers.find(
        (x) => x.lineNumber == lineNumber.toString()
      );
      if (u) {
        Vue.$toast.open({ message: u.error, type: "error" });
      } else {
        Vue.$toast.open({ message: "No user at ", lineNumber, type: "error" });
      }
    },
    async processNewUserToTenantService(nu, connection_id, welcomeUser) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var locUrl =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/users/?connectionId=${connection_id}&shouldSendWelcome=${welcomeUser}`;
      // if (nu && nu.identities && nu.identities.length > 0) {
      //   for (let proIdentity of nu.identities) {
      //     let identityProcess = this.importedUsers.find(
      //         (i) => i.uniqueId === proIdentity.uniqueId
      //     );
      //     if (identityProcess) {
      //       document.getElementById(
      //           identityProcess.lineNumber + "_processing"
      //       ).style.display = "";
      //     }
      //   }
      // }
      //
      // var locUrl =
      //     config.IDENTITY_MANGER +
      //     `/tenants/${this.lastSelectedTenant}/identities/batch?connectionId=${connection_id}&shouldSendWelcome=${welcomeUser}`;
      var new_user_requeust = new Request(locUrl, {
        method: "PUT",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(nu),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var newUserResponse = await fetch(new_user_requeust);
        if (newUserResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          this.closeImportScreen();
          return;
        }
        if (newUserResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          this.closeImportScreen();
          return;
        }
        if (newUserResponse.status === 503) {
          return { error: "ERR_TRY_AGAIN" };
        }
        if (newUserResponse.status != 200) {
          (this.errorMessage = "Error occurred while creating new user: "),
            newUserResponse.status;
          var message = await newUserResponse.json();

          Vue.$toast.open({
            message: message.message,
            type: "error"
          });
          return { error: "ERR_" + newUserResponse.status };
        } else {
          var user_response = await newUserResponse.json();

          if (
            user_response &&
            user_response.identities &&
            Array.isArray(user_response.identities) &&
            user_response.identities.length > 0
          ) {
            for (let resIdentity of user_response.identities) {
              let identity = this.importedUsers.find(
                (i) => i.uniqueId === resIdentity.uniqueId
              );
              if (identity) {
                document.getElementById(
                  identity.lineNumber + "_processing"
                ).style.display = "none";
                if (
                  resIdentity.error &&
                  Array.isArray(resIdentity.error) &&
                  resIdentity.error.length > 0
                ) {
                  identity.errored = user_response.error;
                  identity.processing = false;
                  document.getElementById(
                    identity.lineNumber + "_errored"
                  ).style.display = "";
                  document.getElementById(
                    identity.lineNumber + "_runAgainBTN"
                  ).style.display = "block";
                } else {
                  // identity["User Id"] = userResult.done;
                  identity.errored = null;
                  identity.processing = false;
                  identity.done = true;
                  document.getElementById(
                    identity.lineNumber + "_errored"
                  ).style.display = "none";
                  document.getElementById(
                    identity.lineNumber + "_runAgainBTN"
                  ).style.display = "none";
                  document.getElementById(
                    identity.lineNumber + "_done"
                  ).style.display = "";
                }
              }
            }
          } else {
            console.log("result-error", user_response);
          }

          return { done: user_response.userId };
        }
      } catch (tex) {
        return { error: "Failed to Process User", tex };
      }
    },
    async processNewUser(nu, connection_id, welcomeUser) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      if (nu && nu.identities && nu.identities.length > 0) {
        for (let proIdentity of nu.identities) {
          let identityProcess = this.importedUsers.find(
            (i) => i.uniqueId === proIdentity.uniqueId
          );
          if (identityProcess) {
            document.getElementById(identityProcess.lineNumber + "_processing").style.display = "";
          }
        }
      }

      var locUrl = config.IDENTITY_MANGER + `/tenants/${this.lastSelectedTenant}/identities/batch?connectionId=${connection_id}&shouldSendWelcome=${welcomeUser}`;
      var new_user_requeust = new Request(locUrl, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(nu),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var newUserResponse = await fetch(new_user_requeust);
        if (newUserResponse.status === 403) {
          this.errorMessage = "Uh oh... You don't have the permission required to access this resource";
          this.closeImportScreen();
          return;
        }
        if (newUserResponse.status == 401) {
          this.errorMessage = "Your session has expired please login again to continue";
          this.closeImportScreen();
          return;
        }
        if (newUserResponse.status === 503) {
          return { error: "ERR_TRY_AGAIN" };
        }
        if (newUserResponse.status != 200) {
          (this.errorMessage = "Error occurred while creating new user: "),
            newUserResponse.status;
          return { error: "ERR_" + newUserResponse.status };
        } else {
          var user_response = await newUserResponse.json();
          if (user_response && user_response.identities && Array.isArray(user_response.identities) && user_response.identities.length > 0) {
            for (let resIdentity of user_response.identities) {
              let identity = this.importedUsers.find(
                (i) => i.uniqueId === resIdentity.uniqueId
              );
              if (identity) {
                document.getElementById(identity.lineNumber + "_processing").style.display = "none";
                if (resIdentity.error && Array.isArray(resIdentity.error) && resIdentity.error.length > 0) {
                  identity.errored = user_response.error;
                  identity.processing = false;
                  document.getElementById(identity.lineNumber + "_errored").style.display = "";
                  document.getElementById(identity.lineNumber + "_runAgainBTN").style.display = "block";
                } else {
                  identity.errored = null;
                  identity.processing = false;
                  identity.done = true;
                  document.getElementById(identity.lineNumber + "_errored").style.display = "none";
                  document.getElementById(identity.lineNumber + "_runAgainBTN").style.display = "none";
                  document.getElementById(identity.lineNumber + "_done").style.display = "";
                  document.getElementById(identity.lineNumber + "_processing").style.display = "none";
                }
              }
            }
          } else {
            console.log("result-error", user_response);
          }

          return { done: user_response.userId };
        }
      } catch (tex) {
        return { error: "Failed to Process User", tex };
      }
    },
    async deleteUser(evt) {
      var o = evt.target;
      o.disabled = true;
      var userId = this.deletedUser;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var locUrl =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/users/${userId}`;
      var new_user_requeust = new Request(locUrl, {
        method: "DELETE",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var newUserResponse = await fetch(new_user_requeust);
        if (newUserResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          o.disabled = false;
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (newUserResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          o.disabled = false;
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (newUserResponse.status === 503) {
          o.disabled = false;

          this.errorMessage = "TRY AGAIN!";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
        }
        if (newUserResponse.status != 200) {
          o.disabled = false;
          this.errorMessage = "Failed to delete user";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
        } else {
          Vue.$toast.open({
            message: "Successfully Deleted User",
            type: "success"
          });
          var tableNode = null;
          var rowNode = null;
          var currentNode = o.parentNode;
          while (currentNode) {
            if (currentNode.tagName.toLowerCase() === "tr") {
              rowNode = currentNode;
            } else if (currentNode.tagName.toLowerCase() === "table") {
              tableNode = currentNode;
              break;
            }
            this.users = this.users.filter((u) => u.userId != userId);
            currentNode = currentNode.parentNode;
          }
          if (tableNode) {
            this.users = this.users.filter((u) => u.userId != userId);
          }
        }
      } catch (tex) {
        return { error: "Failed to delete User" };
      }
    },

    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async tryUserAgain(uid) {
      if (uid) {
        var iUser = this.importedUsers.find((x) => x.lineNumber == uid);
        if (iUser) {
          var connection_id = this.currentSelectedConnectionId;
          var shouldWelcomeUserOnImport = document.getElementById("shouldSendWelcomeEmailOnImport").value;
          if (iUser.isValid) {
            iUser.processing = true;
            document.getElementById(iUser.lineNumber + "_processing").style.display = "";
            try {
              let userNotifications = [];
              if (iUser["Alert Status"] && iUser["Alert Status"].toLowerCase() === "yes") {
                if (iUser.Facility === "*") {
                  userNotifications.push({
                    location: "*",
                    unit: "*",
                    area: "*"
                  });
                } else {
                  let userLocation = null;
                  if (iUser.Facility && iUser.Facility.length > 0 && iUser.Facility !== "*") userLocation = this.locationList.find((x) => x.text.indexOf(iUser.Facility) == 0);
                  if (iUser.Location && iUser.Location.length > 0 && iUser.Location !== "*") userLocation = this.locationList.find((x) => x.text.indexOf("/ " + iUser.Location) > 0);
                  if (iUser["Sensor Name"] && iUser["Sensor Name"].length > 0 && iUser["Sensor Name"] !== "*") userLocation = this.locationList.find((x) => x.text.indexOf("/ " + iUser["Sensor Name"]) > 0);

                  if (userLocation && userLocation.value && userLocation.value.lid) {
                    userNotifications.push({
                      location: userLocation.value.lid,
                      unit: userLocation.value.uid || "*",
                      area: userLocation.value.aid || "*"
                    });
                  }
                }
              }

              let Usr = {
                connectionId: connection_id,
                email: iUser.Email,
                employeeId: "",
                locations: iUser.locations,
                units: iUser.units,
                areas: iUser.areas,
                roles: iUser.roles,
                name: {
                  first: iUser["First Name"],
                  last: iUser["Last Name"]
                },
                nfcBadges: [],
                noAuthUser: false,
                phone: iUser["SMS"],
                status: "ACTIVE",
                type: "IDENTITY.STAFF",
                notifications: userNotifications,
                userId: this.lastSelectedTenant + "|" + iUser.Email,
                facility_from_csv: iUser["Facility"],
                location_from_csv: iUser["Location"],
                sensor_from_csv: iUser["Sensor Name"],
                user_type_from_csv: iUser["User Type"],
                role_from_csv: iUser["Role"],
                alert_status_from_csv: iUser["Alert Status"],
                sms_from_csv: iUser["SMS"]
              };
              let uniqueID = this.randomNumber(1, 1000000);
              iUser["uniqueId"] = uniqueID;
              await this.processNewUser(
                {
                  connectionId: connection_id,
                  identities: [{
                    identityData: Usr,
                    uniqueId: uniqueID,
                    userId: Usr.userId
                  }]
                },
                connection_id,
                shouldWelcomeUserOnImport
              );
            } catch (err) {
              iUser.errored = err;
              iUser.processing = false;
              document.getElementById(iUser.lineNumber + "_errored").style.display = "";
              document.getElementById(iUser.lineNumber + "_processing").style.display = "none";
              document.getElementById(iUser.lineNumber + "_runAgainBTN").style.display = "block";

              if (err === "ERROR") {
                throw err;
              }
            }
            iUser.processing = false;
            document.getElementById(iUser.lineNumber + "_processing").style.display = "none";
          }
        }
      }
    },
    randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    async beginImportUser() {
      var shouldWelcomeUserOnImport = document.getElementById("shouldSendWelcomeEmailOnImport").value;
      var connection_id = this.currentSelectedConnectionId;
      var currentObj = this;
      for (var iUser of this.importedUsers) {
        if (iUser.isValid) {
          iUser.processing = true;

          let userNotifications = [];
          if (iUser["Alert Status"] && iUser["Alert Status"].toLowerCase() === "yes") {
            if (iUser.Facility === "*") {
              userNotifications.push({
                location: "*",
                unit: "*",
                area: "*"
              });
            } else {
              let userLocation = null;
              if (iUser.Facility && iUser.Facility.length > 0 && iUser.Facility !== "*") userLocation = this.locationList.find((x) => x.text.indexOf(iUser.Facility) == 0);
              if (iUser.Location && iUser.Location.length > 0 && iUser.Location !== "*") userLocation = this.locationList.find((x) => x.text.indexOf("/ " + iUser.Location) > 0);
              if (iUser["Sensor Name"] && iUser["Sensor Name"].length > 0 && iUser["Sensor Name"] !== "*") userLocation = this.locationList.find((x) => x.text.indexOf("/ " + iUser["Sensor Name"]) > 0);

              if (userLocation && userLocation.value && userLocation.value.lid) {
                userNotifications.push({
                  location: userLocation.value.lid,
                  unit: userLocation.value.uid || "*",
                  area: userLocation.value.aid || "*"
                });
              }
            }
          }

          let Usr = {
            connectionId: connection_id,
            email: iUser.Email,
            employeeId: "",
            locations: iUser.locations,
            units: iUser.units,
            areas: iUser.areas,
            roles: iUser.roles,
            name: {
              first: iUser["First Name"],
              last: iUser["Last Name"]
            },
            nfcBadges: [],
            noAuthUser: false,
            phone: iUser["SMS"],
            status: "ACTIVE",
            type: "IDENTITY.STAFF",
            notifications: userNotifications,
            userId: this.lastSelectedTenant + "|" + iUser.Email,
            facility_from_csv: iUser["Facility"],
            location_from_csv: iUser["Location"],
            sensor_from_csv: iUser["Sensor Name"],
            user_type_from_csv: iUser["User Type"],
            role_from_csv: iUser["Role"],
            alert_status_from_csv: iUser["Alert Status"],
            sms_from_csv: iUser["SMS"]
          };
          iUser.processing = true;
          let uniqueID = this.randomNumber(1, 1000000);
          iUser["uniqueId"] = uniqueID;
          try {
            await currentObj.processNewUser(
              {
                connectionId: connection_id,
                identities: [{
                  identityData: Usr,
                  uniqueId: uniqueID,
                  userId: Usr.userId
                }]
              },
              connection_id,
              shouldWelcomeUserOnImport
            );
          } catch (err) {
            iUser.errored = err;
            iUser.processing = false;
            document.getElementById(iUser.lineNumber + "_errored").style.display = "";
            document.getElementById(iUser.lineNumber + "_processing").style.display = "none";
            document.getElementById(iUser.lineNumber + "_runAgainBTN").style.display = "block";

            if (err === "ERROR") {
              throw err;
            }
          }
        }
      }
    },
    closeImportScreen() {
      this.isImportingUserOperation = false;
      this.importedUsers = null;
      this.currentSelectedConnectionId = "-Select Authentication Mechanism-";
      this.importLoadingMessage = "";
      //  this.fetchUsers();

      // this.getSelectedUser();
      // this.onSelectUser();
    },
    async getConnections() {
      loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.currentSelectedConnectionId = "-Select Authentication Mechanism-";
      this.currentTenantsConnectionIds = [];
      this.importedUsers = null;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var locUrl = config.TENET_SERVICE + `/tenants/${this.lastSelectedTenant}`;
      var tenants_list_request = new Request(locUrl, {
        method: "GET",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          this.closeImportScreen();
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          this.closeImportScreen();
          return;
        }
        if (tenantListResponse.status === 503) {
          return this.getConnections();
        }
        if (tenantListResponse.status != 200) {
          this.errorMessage =
            "APIs are warming up. Please refresh the page in a few seconds.";
          this.closeImportScreen();
          return;
        } else {
          var tenantsBody = await tenantListResponse.json();
          this.errorMessage = "";
          return tenantsBody.routes
            .map(function(r) {
              if (r.type === "ROUTES_URL") {
                return r.connectionId;
              }
            })
            .filter((x) => x != null);
        }
      } catch (tex) {
        this.errorMessage = "Failed to get tenant due to an error.";
        this.closeImportScreen();

        return;
      }
    },
    async showImportScreen() {
      //var connections = await this.getConnections();
      //document.getElementById("fileInput").click();
      this.isImportingUserOperation = true;
    },
    async showFileImportScreen() {
      //var connections = await this.getConnections();
      document.getElementById("fileInput").click();
      this.isImportingUserOperation = true;
    },
    isImportedUserValid(u) {
      if (u.Facility && u.Location && u["Sensor Name"] && u.Facility.length > 0 && u.Location.length > 0 && u["Sensor Name"].length > 0) {
        if (u.Facility != "*") {
          var userLoc = this.locationList.find((x) => x.text.indexOf(u.Facility) == 0);
          if (!userLoc) {
            u.error = "Facility Not Found";
            return false;
          }
          if (userLoc && userLoc.value && userLoc.value.lid) u.locations = [userLoc.value.lid];
        }
        if (u.Location != "*") {
          var userLoc = this.locationList.find((x) => x.text.indexOf("/ " + u.Location) > 0);
          if (!userLoc) {
            u.error = "Location Not Found";
            return false;
          }
          if (userLoc && userLoc.value && userLoc.value.uid) u.units = [userLoc.value.uid];
        }
        if (u["Sensor Name"] != "*") {
          var userLoc = this.locationList.find((x) => x.text.indexOf("/ " + u["Sensor Name"]) > 0);
          if (!userLoc) {
            u.error = "Sensor Name Not Found";
            return false;
          }
          if (userLoc && userLoc.value && userLoc.value.aid) u.areas = [userLoc.value.aid];
        }
      } else {
        u.error = "Place of Service (Facility, Location or Sensor Name) is EMPTY";
        return false;
      }
      if (!u["First Name"] || u["First Name"].length === 0 || !u["Last Name"] || u["Last Name"].length === 0) {
        u.error = "[First Name] & [Last Name] is required";
        return false;
      }
      if (!u["Role"] || u["Role"].length === 0) {
        u.error = "Role is required";
        return false;
      }
      if (u["Role"]) {
        u["roles"] = [];
        const roles = u["Role"] && u["Role"].split(",");
        if (roles && roles.length > 0 && this.roles) {
          let missingRoles = [];
          const rolesKeys = Object.keys(this.roles);
          for (const role of roles) {
            if (role && role.trim()) {
              const availableRole = rolesKeys.find((r) => r === role.trim());
              if (!availableRole) missingRoles.push(role.trim());
              else u["roles"].push(role.trim());
            }
          }
          if (missingRoles.length > 0) {
            u.error = "Following roles did not match with what is configured for this tenant. Unmatched Roles: " + missingRoles.join(", ");
            return false;
          }
        }
      }
      if (!u.Email || u.Email.length === 0 || u.Email.indexOf("@") <= 0) {
        u.error = "[Email] is not valid";
        return false;
      }
      if (["tgh-auth-db", "tcv-auth-db"].includes(this.currentSelectedConnectionId)) {
        if (!u.Username || u.Username.length === 0) {
          u.error = "[Username] is not valid";
          return false;
        }
      }
      if (this.currentSelectedConnectionId.toLowerCase().indexOf("-saml") > 0) {
        if (!u["User Id"] || u["User Id"].length === 0) {
          u.error = "[UserId] is required for SAML";
          return false;
        }
      }
      if (u.SMS && u.SMS.length > 0 && (u.SMS.length < 10 || u.SMS.length > 11)) {
        u.error = "[SMS] is not valid";
        return false;
      }
      u.error = null;

      return true;
    },
    handleFiles(event) {
      this.importLoadingMessage = "Loading file: " + event.target.files[0];
      //alert(this.importLoadingMessage);
      //Vue.$toast.open("Loading File");
      // Check for the various File API support.
      if (window.FileReader) {
        // FileReader are supported.
        //getAsText(files[0]);
        var fileToRead = event.target.files[0];
        var reader = new FileReader();
        // Handle errors load
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            // this.importLoadingMessage = "ERROR reading file";
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            this.importedUsers = null;

            // alert("Cannot read file !");
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          this.importedUsers = null;
          var csv = event.target.result;
          var allTextLines = csv.split(/\r\n|\n/);
          var lines = [];
          var headers = this.CSVtoArray(allTextLines.shift());
          this.importLoadingMessage = "Validating Headers";
          if (!this.validateHeaders(headers)) {
            this.importLoadingMessage =
              "Validation Failed! Missing: " + this.importLoadingMessage;
            Vue.$toast.open({
              message: this.importLoadingMessage,
              type: "error"
            });
            return false;
          }
          this.importLoadingMessage = "Loading Users";
          var listOfUsers = [];
          while (allTextLines.length - 1) {
            listOfUsers.push(
              this.csvArrayToJSON(
                headers,
                this.CSVtoArray(allTextLines.shift())
              )
            );
          }
          this.importedUsers = [];
          var lineNumber = 0;

          if (listOfUsers.length > 0) {
            listOfUsers.forEach((u) => {
              if (!u) {
                u = {};
              }
              ++lineNumber;
              u.lineNumber = lineNumber;

              if (u.Email && u.Email.length > 0 && u.Email.indexOf("@") && this.currentSelectedConnectionId.indexOf("saml")) {
                u["User Id"] = this.currentSelectedConnectionId + "|" + u.Email.toLowerCase();
              }
              u["Name"] = u["First Name"] + " " + u["Last Name"];

              if (u.SMS && u.SMS.length > 0) {
                u.SMS = u.SMS.replace(/\D/g, "");
                if (u.SMS.length >= 11) {
                  u.SMS = "+" + u.SMS;
                }
              }
              for (var key in u) {
                if (u[key] && typeof u[key] === "string") {
                  u[key] = u[key].trim();
                }
              }
              u.isValid = this.isImportedUserValid(u);
              this.importedUsers.push(u);
            });
            this.importLoadingMessage = "Loaded Users: " + this.importedUsers.length;
            //this.importedUsers = listOfUsers;
          } else {
            this.importLoadingMessage = "No users defined";
            this.importedUsers = null;
          }
        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        this.importLoadingMessage = "Cannot read file";
        // alert("FileReader are not supported in this browser.");
        Vue.$toast.open({
          message: "FileReader are not supported in this browser",
          type: "error"
        });
      }
    },
    validateHeaders(headers) {
      if (headers && Array.isArray(headers) && headers.length >= 8) {
        var errMsg = "";
        if (!headers.includes("Facility")) {
          errMsg += "\r\n- Facility";
        }
        if (!headers.includes("Location")) {
          errMsg += "\r\n- Location";
        }
        if (!headers.includes("Sensor Name")) {
          errMsg += "\r\n- Sensor Name";
        }
        if (!headers.includes("First Name")) {
          errMsg += "\r\n- First Name";
        }
        if (!headers.includes("Last Name")) {
          errMsg += "\r\n- Last Name";
        }
        if (!headers.includes("Email")) {
          errMsg += "\r\n- Email";
        }
        if (!headers.includes("SMS")) {
          errMsg += "\r\n- SMS";
        }
        if (!headers.includes("Alert Status")) {
          errMsg += "\r\n- Alert Status";
        }
        if (!headers.includes("Role")) {
          errMsg += "\r\n- Role";
        }

        if (
          ["tcv-auth-db", "tgh-auth-db"].includes(
            this.currentSelectedConnectionId
          ) &&
          !headers.includes("Username")
        ) {
          errMsg += "\r\n- Username (required for KP/TGH)";
        }
        // if (
        //   !["hclm-saml"].includes(this.currentSelectedConnectionId) &&
        //   this.currentSelectedConnectionId.toLowerCase().indexOf("saml") >= 0 &&
        //   !headers.includes("User Id")
        // ) {
        //   errMsg += "\r\n- User Id (required for SAML connection)";
        // }
        if (errMsg.length > 0) {
          this.importLoadingMessage = errMsg;
          return false;
        }
        return true;
      } else {
        this.importLoadingMessage =
          "Invalid File Headers! Please check the requirements";
        return false;
      }
    },
    csvArrayToJSON(headers, data) {
      if (headers && data) {
        var obj = {};
        for (var hIdx in headers) {
          var key = headers[hIdx].trim();
          if (key && key.length > 0) {
            obj[key] = data.length - 1 < hIdx ? null : data[hIdx];
          }
        }
        return obj;
      }
      return false;
    },
    CSVtoArray(text) {
      var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
      //var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
      var re_value = /(?!\s*$)\s*(?:"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,"\s\\]*(?:\s+[^,"\s\\]+)*))\s*(?:,|$)/g;
      // Return NULL if input string is not well formed CSV string.
      if (!re_valid.test(text)) {
        if (!re_value.test(text)) {
          return null;
        }
      }

      var a = []; // Initialize array to receive values.
      text.replace(
        re_value, // "Walk" the string using replace with callback.
        function(m0, m1, m2, m3) {
          // Remove backslash from \' in single quoted values.
          if (m1 !== undefined) a.push(m1.replace(/\\"/g, "\"").trim());
          // Remove backslash from \" in double quoted values.
          else if (m2 !== undefined) a.push(m2.replace(/\\"/g, "\"").trim());
          else if (m3 !== undefined) a.push(m3.trim());
          return ""; // Return empty string.
        }
      );
      // Handle special case of empty last value.
      if (/,\s*$/.test(text)) a.push("");
      return a;
    },
    showAssignedNotifications(u) {
      if (u.notifications) {
        var html = "";
        u.notifications.forEach((nObj) => {
          if (nObj.location === "*" && nObj.unit === "*") {
            html += "<span class=\"smallFont\">All Locations </span><br/>";
          } else if (nObj.unit === "*" && nObj.location != "*") {
            var loc = this.locationList.find(
              (x) =>
                x.value &&
                x.value.lid === nObj.location &&
                !x.value.uid &&
                !x.value.area
            );
            if (loc) {
              html += `<span class="smallFont">${loc.text}</span><br/>`;
            }
          } else {
            var loc = this.locationList.find(
              (x) =>
                x.value &&
                x.value.lid === nObj.location &&
                x.value.uid === nObj.unit &&
                ((!x.value.aid && !nObj.area) || x.value.aid === nObj.area)
            );
            if (loc) {
              html += `<span class="smallFont">${loc.text}</span><br/>`;
            }
          }
        });
        return html;
      }
      return "<span class=\"smallFont\">Not Subscribed</span>";
    },
    showAssignedLocationNotifications(u) {
      var locnot = "";
      if (u) {
        if (u.location === "*" && u.unit === "*") {
          locnot = "All Locations";
        } else if (u.unit === "*" && u.location != "*") {
          var loc = this.locationList.find(
            (x) =>
              x.value &&
              x.value.lid === u.location &&
              !x.value.uid &&
              !x.value.area
          );
          if (loc) {
            locnot = loc.text;
          }
        } else {
          var loc = this.locationList.find(
            (x) =>
              x.value &&
              x.value.lid === u.location &&
              x.value.uid === u.unit &&
              ((!x.value.aid && !u.area) || x.value.aid === u.area)
          );
          if (loc) {
            locnot = loc.text;
          }
        }
        return locnot;
      }
    },
    showAssignedLocations(u) {
      var locnot = "";
      if (u) {
        if (u.location === "*" && u.unit === "*") {
          locnot = "All Locations";
        } else if (u.unit === "*" && u.location != "*") {
          var loc = this.locationList.find(
            (x) =>
              x.value &&
              x.value.lid === u.location &&
              !x.value.uid &&
              !x.value.area
          );
          if (loc) {
            locnot = loc.text;
          }
        } else {
          var loc = this.locationList.find(
            (x) =>
              x.value &&
              x.value.lid === u.location &&
              x.value.uid === u.unit &&
              ((!x.value.aid && !u.area) || x.value.aid === u.area)
          );
          if (loc) {
            locnot = loc.text;
          }
        }
        return locnot;
      }
    },
    getLocationIndex(locObj, CurrUser) {
      let returnVal = false;
      if (locObj.value === "*") {
        returnVal = true;
      } else {
        if (locObj.value.lid && locObj.value.uid && locObj.value.aid) {
          if (
            this.locationList.find(
              (e) =>
                CurrUser.locations.indexOf(e.value.lid) !== -1 &&
                CurrUser.units.indexOf(e.value.uid) !== -1 &&
                CurrUser.areas.indexOf(e.value.aid) !== -1
            )
          ) {
            returnVal = true;
          } else {
            returnVal = false;
          }
        } else if (locObj.value.lid && locObj.value.uid) {
          if (
            this.locationList.find(
              (e) =>
                CurrUser.locations.indexOf(e.value.lid) !== -1 &&
                CurrUser.units.indexOf(e.value.uid) !== -1
            )
          ) {
            returnVal = true;
          } else {
            returnVal = false;
          }
        } else if (locObj.value.lid) {
          if (
            this.locationList.find(
              (e) => CurrUser.locations.indexOf(e.value.lid) !== -1
            )
          ) {
            returnVal = true;
          } else {
            returnVal = false;
          }
        } else {
          returnVal = false;
        }
      }
      return returnVal;
    },
    async removeLocation(item) {
      alert(item);
      this.currentSelectedUser.locations.splice(item, 1);
    },
    async removeLocationNotification(item) {
      this.currentSelectedUser.notifications.splice(item, 1);
    },
    assignLocationToUser() {
      var loc = JSON.parse(document.getElementById("assignLocationSB").value);
      let locationMap = this.locationListBkp.find((l) => l.id == loc.lid);
      if (!Array.isArray(this.currentSelectedUser.locations)) {
        if (this.currentSelectedUser.locations === "*") {
          return;
        }
        if (!this.currentSelectedUser.locations) {
          this.currentSelectedUser.locations = [];
        } else {
          this.currentSelectedUser.locations = [
            this.currentSelectedUser.locations
          ];
        }
      }
      if (this.currentSelectedUser.locations.indexOf(loc.lid) < 0) {
        if (loc.lid) {
          if (loc.lid && loc.uid == undefined) {
            this.currentSelectedUser.locations.push(loc.lid);
            locationMap.units.forEach((a) => {
              this.currentSelectedUser.units.push(a.id);

              a.areas.forEach((b) => {
                this.currentSelectedUser.areas.push(b.id);
              });
            });
          } else {
            this.currentSelectedUser.locations.push(loc.lid);
          }
        } else {
          this.currentSelectedUser.locations = "*";
        }
      }

      if (loc.uid && loc.uid != "*") {
        if (!this.currentSelectedUser.units) {
          this.currentSelectedUser.units = [];
        }
        if (!Array.isArray(this.currentSelectedUser.units)) {
          this.currentSelectedUser.units = [];
        }
        if (this.currentSelectedUser.units.indexOf(loc.uid) < 0) {
          this.currentSelectedUser.units.push(loc.uid);
        }
      }
      if (loc.aid && loc.aid != "*") {
        if (!this.currentSelectedUser.areas) {
          this.currentSelectedUser.areas = [];
        }
        if (!Array.isArray(this.currentSelectedUser.areas)) {
          this.currentSelectedUser.areas = [];
        }
        if (this.currentSelectedUser.areas.indexOf(loc.aid) < 0) {
          this.currentSelectedUser.areas.push(loc.aid);
        }
      }
      this.currentSelectedUser.assignedLocation = this.getLocation(
        this.currentSelectedUser,
        this.locationList
      );
    },
    clearUserLocation() {
      this.currentSelectedUser.locations = [];
      this.currentSelectedUser.areas = [];
      this.currentSelectedUser.units = [];
      this.currentSelectedUser.assignedLocation = this.getLocation(
        this.currentSelectedUser,
        this.locationList
      );
    },
    clearNotifications() {
      this.currentSelectedUser.subscribedToNotifications = false;
      this.currentSelectedUser.notifications = [];
      this.currentSelectedUser.assignedNotifications =
        this.showAssignedNotifications(this.currentSelectedUser);
    },
    assignNotificationToUser() {
      var notify = JSON.parse(
        document.getElementById("assignNotificationSB").value
      );
      if (Array.isArray(this.currentSelectedUser.notifications)) {
        if (
          this.currentSelectedUser.notifications.find(
            (e) => e.location == notify.lid && e.unit === "*"
          )
        ) {
          return;
        }
      }
      if (!this.currentSelectedUser.notifications) {
        this.currentSelectedUser.notifications = [];
      }

      if (
        this.currentSelectedUser.notifications.indexOf(
          (x) =>
            x.location === notify.lid &&
            x.unit === notify.uid &&
            ((!x.area && !notify.aid) || x.area == notify.aid)
        ) >= 0
      ) {
      } else {
        var newObj = {
          location: notify.lid,
          unit: notify.uid ? notify.uid : "*",
          startTime: new Date(),
          endTime: new Date(Date.now() + 63113904000)
        };
        if (notify.aid) {
          newObj.area = notify.aid;
        }
        if (
          this.currentSelectedUser.notifications.find(
            (e) =>
              e.location == notify.lid &&
              e.unit == notify.uid &&
              e.area == notify.aid
          ) ||
          this.currentSelectedUser.notifications.find(
            (e) =>
              e.location == notify.lid &&
              (e.unit == "*" || e.unit == notify.uid)
          ) ||
          this.currentSelectedUser.notifications.find(
            (e) =>
              e.location == notify.lid &&
              e.unit == notify.uid &&
              (e.area == "*" || !e.area)
          )
        ) {
          return;
        } else {
          this.currentSelectedUser.notifications.push(newObj);
          /*  if (notify.lid && !notify.uid && this.currentSelectedUser.notifications.length) {
            return
          } else {
            this.currentSelectedUser.notifications.push(newObj);
          } */
        }
      }
      this.currentSelectedUser.assignedNotifications =
        this.showAssignedNotifications(this.currentSelectedUser);
    },

    onSelectUser(user) {
      //   this.otherUser = {...user};
      // this.currentSelectedUser.assignedLocation = this.otherUser.assignedLocation;
      this.selectedUsers = [];
      this.currentSelectedUser = user;
      this.selectedUsers.push(user);
      // this.getSelectedUser();
      this.inviteUsers = [];
      // this.fetchUsers();
    },
    clearUsers() {
      this.selectedUsers = [];
    },
    async resetPassword() {
      if (this.currentSelectedUser) {
        document.getElementById("resetPasswordBTN").disabled = true;
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var userId = this.currentSelectedUser.userId;
        if (userId && userId.indexOf("auth0|") < 0) {
          //  alert("Sorry cannot reset password for this user.");
          Vue.$toast.open({
            message: "Sorry cannot reset password for this user.",
            type: "error"
          });
          return;
        }

        var locUrl =
          config.TENET_SERVICE +
          `/tenants/${this.lastSelectedTenant}/users/${this.currentSelectedUser.userId}/reset-password`;
        var tenants_list_request = new Request(locUrl, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({}),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        });
        try {
          var tenantListResponse = await fetch(tenants_list_request);
          if (tenantListResponse.status === 403) {
            this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
            document.getElementById("saveUserBtn").disabled = false;
            return;
          }
          if (tenantListResponse.status == 401) {
            this.errorMessage =
              "Your session has expired please login again to continue";
            document.getElementById("saveUserBtn").disabled = false;
            return;
          }
          if (tenantListResponse.status == 503) {
            (this.errorMessage =
              "Error occurred while reseting password for  user: "),
              tenantListResponse.status;
            Vue.$toast.open({
              message: "Please try to reset password again",
              type: "error"
            });
            return;
          } else if (tenantListResponse.status != 200) {
            Vue.$toast.open({
              message: "Failed to reset password due to a restriction",
              type: "error"
            });
            return;
          } else {
            document.getElementById("resetPasswordBTN").disabled = false;
            // alert("Sent password reset email");
            Vue.$toast.open({
              message: "Sent password reset email",
              type: "success"
            });
          }
        } catch (tex) {
          // alert("Failed to reset password due to an error");
          Vue.$toast.open({
            message: "Failed to reset password due to an error",
            type: "error"
          });
          document.getElementById("resetPasswordBTN").disabled = false;

          return;
        }
      }
      //this.clearUser();
    },
    unblockUser() {
      this.clearUser();
    },
    getSelectedUser() {
      if (this.selectedUsers && this.selectedUsers.length === 1) {
        this.currentSelectedUser = this.users.find(
          (u) => u.userId === this.selectedUsers[0].userId
        );
        return this.currentSelectedUser;
      }
      return null;
    },
    clearUser() {
      this.currentSelectedUser.subscribedToNotifications = false;
      this.currentSelectedUser.notifications = [];
      this.currentSelectedUser.assignedNotifications =
        this.showAssignedNotifications(this.currentSelectedUser);
      this.currentSelectedUser.assignedLocation = null;
      //   this.currentSelectedUser.assignedLocation = this.otherUser.assignedLocationInfo;
      this.currentSelectedUser = null;
      this.selectedUsers = [];
      //   this.currentSelectedUser = this.otherUser;
      //   this.fetchUsers();
      //   debugger;
      //   this.currentSelectedUser.assignedLocation = this.otherUser.assignedLocationInfo;
      //   this.currentSelectedUser.assignedLocation = this.currentSelectedUser.assignedLocationInfo;
      //    console.log("test"+ this.otherUser.assignedLocationInfo);
    },
    async saveUser() {
      document.getElementById("saveUserBtn").disabled = true;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var firstName = document.getElementById("userfirstName").value;
      var lastName = document.getElementById("userlastName").value;
      var phone = document
        .getElementById("userPhone")
        .value.replace(/-/g, "")
        .replace(/ /g, "")
        .replace("(", "")
        .replace(")", "");
      if (phone.length > 0 && (phone.length > 11 || phone.length < 10)) {
        // alert("Bad phone number must be: 000-000-0000");
        Vue.$toast.open({
          message: "Bad phone number must be: 000-000-0000",
          type: "error"
        });
        document.getElementById("saveUserBtn").disabled = false;
        return;
      }
      if (
        firstName &&
        firstName.trim().length > 1 &&
        firstName.trim().length < 100 &&
        lastName.trim().length > 1 &&
        lastName.trim().length < 100
      ) {
        if (!this.currentSelectedUser.name) {
          this.currentSelectedUser.name = {};
        }
        this.currentSelectedUser.name.first = firstName;
        this.currentSelectedUser.name.last = lastName;
        this.currentSelectedUser.phone = phone;
      } else {
        // alert("Bad first/last name");
        Vue.$toast.open({ message: "Bad first/last name", type: "error" });
        document.getElementById("saveUserBtn").disabled = false;
        return;
      }
      var requestBody = JSON.stringify(this.currentSelectedUser);
      var locUrl =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/users/${this.currentSelectedUser.userId}`;
      var tenants_list_request = new Request(locUrl, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: requestBody,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          document.getElementById("saveUserBtn").disabled = false;
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          document.getElementById("saveUserBtn").disabled = false;
          return;
        }
        if (tenantListResponse.status === 503) {
          return this.saveUser();
        }
        if (tenantListResponse.status != 200) {
          this.errorMessage =
            "APIs are warming up. Please refresh the page in a few seconds.";
          document.getElementById("saveUserBtn").disabled = false;
          return;
        } else {
          var tenantsBody = await tenantListResponse.json();
          document.getElementById("saveUserBtn").disabled = false;
          Vue.$toast.open({ message: "Done saving user", type: "success" });
          this.errorMessage = "";

          // if (
          //   this.users.find((e) => e.userId == this.currentSelectedUser.userId)
          // ) {
          //   let userIndex = this.users.findIndex(
          //     (e) => e.userId == this.currentSelectedUser.userId
          //   );
          //   this.users[userIndex].locations =
          //     this.currentSelectedUser.locations;
          //   this.users[userIndex].notifications =
          //     this.currentSelectedUser.notifications;
          //   this.users[userIndex].assignedLocation =
          //     this.currentSelectedUser.assignedLocation;
          //   this.users[userIndex].subscribedToNotifications =
          //     this.currentSelectedUser.subscribedToNotifications;

          //   this.users[userIndex].assignedLocationInfo =
          //     this.currentSelectedUser.assignedLocationInfo;
          //   console.log("selected User 2", this.users[userIndex]);
          //   console.log("selected User 3", this.currentSelectedUser);
          //   // u.assignedLocation = this.getLocation(u, this.locationList);
          //   // u.assignedNotifications = this.showAssignedNotifications(u);
          //   // u.assignedLocationInfo = this.getLocation(u, this.locationList); = this.currentSelectedUser;
          // }

          // this.clearUser();
          this.users = [];
          this.fetchUsers();
        }
      } catch (tex) {
        this.errorMessage = "Failed to update user due to an error.";
        document.getElementById("saveUserBtn").disabled = false;

        return;
      }
      this.clearUser();
    },
    async changeTenantView() {
      this.selectedUsers = [];
      this.users = [];
      this.filterString = "";
      this.currentSelectedConnectionId = "-Select Authentication Mechanism-";
      this.currentTenantsConnectionIds = [];
      this.importedUsers = null;
      this.closeImportScreen();

      var connections = await this.getConnections();
      if (connections && connections.length > 0 && Array.isArray(connections)) {
        this.currentTenantsConnectionIds = connections;
      }
      await this.fetchTenantLocations();
      await this.fetchUsers();
    },
    showSelectedUsers() {
      if (!this.selectedUsers || this.selectedUsers.length === 0) {
        return "";
      }
      var html = "";
      this.selectedUsers.forEach(function(d) {
        html += `<div class="card" style="margin-top:5px"><span class="darkMatter" style="font-size:0.8em!important;font-weight:bolder;display:block!important;text-align:left">UserId: ${d.split("+")[0]
        }</span><span class="smallFont" style="font-size:0.8em!important;display:block!important;text-align:left">Name: ${d.split("+")[1]
        }</span></div>`;
      });
      return html;
    },
    getLocation(user, locationList) {
      var locations = user.locations;
      var units = user.units;
      var areas = user.areas;
      var locs = "";
      if (
        !locations &&
        !units &&
        !areas &&
        user.userId &&
        user.userId.indexOf("google-apps|") >= 0 &&
        user.userId.indexOf("@care.ai") > 0
      ) {
        return "<span class=\"smallFont\">GOD ACCESS</span>";
      }
      if (locations) {
        // debugger;
        if (locations === "*") {
          return "<span class=\"smallFont\">Everything</span>";
        }
        if (!Array.isArray(locations)) {
          if (locations === "*") {
            locations = this.locationList
              .map(function(x) {
                return x.value && !x.value.uid ? x.value.lid : null;
              })
              .filter((y) => y != null);
          } else {
            return "<span class=\"UNKNOWN\"></span>";
          }
        }

        locations.forEach((l) => {
          let locData = this.locationListBkp.find((e) => e.id === l);
          if (
            units &&
            units != "*" &&
            Array.isArray(units) &&
            units.length > 0 &&
            units[0] != "*" &&
            locData &&
            locData.units &&
            locData.units.find((e) => units.indexOf(e.id) !== -1)
          ) {
            units.forEach((u) => {
              let unitData = locData.units.find((e) => e.id === u);
              if (
                areas &&
                areas != "*" &&
                Array.isArray(areas) &&
                areas.length > 0 &&
                areas[0] != "*" &&
                unitData &&
                unitData.areas &&
                unitData.areas.find((e) => areas.indexOf(e.id) !== -1)
              ) {
                areas.forEach((a) => {
                  var assignedArea = locationList.find(
                    (x) =>
                      x.value &&
                      x.value.lid == l &&
                      x.value.uid === u &&
                      x.value.aid === a
                  );
                  if (assignedArea) {
                    locs +=
                      "<span class=\"smallFont\">" +
                      assignedArea.text +
                      "</span><br/>";
                  }
                });
              } else {
                var assignedUnit = locationList.find(
                  (x) => x.value && x.value.lid == l && x.value.uid == u
                );
                if (assignedUnit) {
                  locs +=
                    "<span class=\"smallFont\">" +
                    assignedUnit.text +
                    "</span><br/>";
                }
              }
            });
          } else {
            var assignedLocation = locationList.find(
              (x) => x.value && x.value.lid == l
            );
            if (assignedLocation) {
              locs +=
                "<span class=\"smallFont\">" +
                assignedLocation.text +
                "</span><br/>";
            } else {
              // console.log("Not Found");
            }
          }
        });
        return locs.length === 0 ? "<span class=\"UNKNOWN\"></span>" : locs;
      } else {
        return "<span class=\"smallFont\">From Auth0 User Configuration</span>";
      }
    },
    async getLocations(tenantId, id_token) {
      var locUrl =
        config.TENET_SERVICE +
        `/tenants/${tenantId}/locations?limit=1000&isActive=true`;
      var tenants_list_request = new Request(locUrl, {
        method: "GET",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";

          return;
        }
        if (tenantListResponse.status === 503) {
          return this.getLocations(tenantId, id_token);
        }
        if (tenantListResponse.status != 200) {
          this.errorMessage =
            "APIs are warming up. Please refresh the page in a few seconds.";
        } else {
          var tenantsBody = await tenantListResponse.json();

          this.locationList = [{ text: "ALL", value: "*" }];
          this.locationNotifyList = [];
          var locations = [];
          this.locationListBkp = tenantsBody.locations;
          tenantsBody.locations.forEach(function(l) {
            locations.push({
              text: l.name + "/All locations",
              value: { lid: l.id }
            });
            l.units.forEach(function(u) {
              locations.push({
                text: l.name + " / " + u.name,
                value: { lid: l.id, uid: u.id }
              });
              u.areas.forEach(function(a) {
                locations.push({
                  text: l.name + " / " + u.name + " / " + a.name,
                  value: { lid: l.id, uid: u.id, aid: a.id }
                });
              });
            });
          });
          this.locationList = [...this.locationList, ...locations];
          this.locationNotifyList = [...this.locationNotifyList, ...locations];
          //console.log(this.locationList);
          this.errorMessage = "";
        }
      } catch (tex) {
        this.errorMessage =
          "Failed to get tenant location list due to an error.";
      }
    },
    check(data, value) {
      this.userList.forEach((e) => {
        e.selected = false;
      });
      if (value == true) {
        this.selectedUser = data.user;
        data["selected"] = value;
      } else {
        if (this.selectedUsersMail.length == 1) {
          this.selectedUser = "";
        }
      }
    },
    async fetchRoles() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;

      if (this.lastSelectedTenant) {
        var role_list_request = new Request(
          config.IDENTITY_MANGER + `/tenants/${this.lastSelectedTenant}/roles`,
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json"
            }
          }
        );
        try {
          var roleListResponse = await fetch(role_list_request);

          if (roleListResponse.status === 403) {
            this.errorMessage = "Uh oh... You don't have the permission required to access this resource";
            return;
          }
          if (roleListResponse.status == 401) {
            this.errorMessage = "Your session has expired please login again to continue";
            return;
          }
          if (roleListResponse.status == 503) {
            return this.fetchRoles();
          }
          if (roleListResponse.status != 200) {
            this.errorMessage = "Failed to get data";
          } else {
            var roles = await roleListResponse.json();

            this.roles = roles;
            this.errorMessage = "";

            console.log("roles", this.roles);
          }
        } catch (tex) {
          this.errorMessage = "Failed to get tenant roles due to an error.";
        }
      }
    },
    async fetchData() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      this.selectedUsers = [];

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",

        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          return;
        }
        if (tenantListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";

          return;
        }
        if (tenantListResponse.status === 503) {
          return this.fetchData();
        }
        if (tenantListResponse.status != 200) {
          (this.errorMessage = "Error occurred while fetching tenant list: "),
            tenantListResponse.status;

          return;
        } else {
          //console.log(tenantListResponse);
          var tenantsBody = await tenantListResponse.json();
          //console.log(tenantsBody);
          this.tenants = tenantsBody.map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace("-", "")
            };
          });
          this.tenants = this.tenants.sort(function(a, b) {
            var nameA = a.text ? a.text.toUpperCase() : ""; // ignore upper and lowercase
            var nameB = b.text ? b.text.toUpperCase() : ""; // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          });
          this.errorMessage = "";
          this.tenants.forEach((e) =>
            this.tenantsList.push({ id: e.value, name: e.text || e.value })
          );
        }
      } catch (tex) {
        this.errorMessage = "Failed to get tenant list due to an error.";
      }
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id;
      } else {
        return "";
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.changeTenantView();
      this.fetchRoles();
    },
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.id == tenant || e.name == tenant);
    },
    async fetchTenantLocations() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      await this.getLocations(this.lastSelectedTenant, id_token);
    },
    async fetchUsers() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      this.usersListEmpty = false;
      // await this.getLocations(this.lastSelectedTenant, id_token);
      var next = this.nextUsersPointer || "limit=1000&offset=0";
      var user_list_request = new Request(
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/users?${next}`,
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );
      try {
        var userListResponse = await fetch(user_list_request);
        if (userListResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";

          return;
        }
        if (userListResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";

          return;
        }
        if (userListResponse.status === 503) {
          return this.fetchUsers();
        }
        if (userListResponse.status != 200) {
          (this.errorMessage = "Error occurred while fetching tenant list: "),
            userListResponse.status;

          return;
        } else {
          var users = await userListResponse.json();
          // users.users.forEach((u) => {
          //   u.assignedLocation = this.getLocation(u, this.locationList);
          //   u.assignedNotifications = this.showAssignedNotifications(u);
          //   u.assignedLocationInfo = this.getLocation(u, this.locationList);
          //   //  u.assignedNotifications1 = this.showAssignedNotifications(u);
          // });
          if (users.count==0) {
             loader.hide();
              this.usersListEmpty = true;
            } else if(users.count>0){
              loader.hide();
              this.usersListEmpty = false;
            }
          this.users = this.users != null && this.users.length > 0 ? [...this.users, ...users.users] : users.users;
          this.usersBackUp = this.users;

          this.nextUsersPointer = users.next;

          var page = users.count;
          if (this.nextUsersPointer) {
            page = parseInt(users.next.split("offset=")[1]);
            this.fetchUsers();
          }
          this.userMessage = "Listing " + page + "of " + users.count;
          this.errorMessage = "";
        }
      } catch (tex) {
        this.errorMessage = "Failed to get tenant users due to an error.";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
  url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
  url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

.pageHeaderTitle {
  padding-left: 15px !important;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}
.pageHeader .filterWrapper .dropdown:before {
  border: solid #fff;
  border-width: 0 1px 1px 0;
}

::v-deep .ui.selection.dropdown .menu .item{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // max-width: 334px;
    margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}
::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

.requiredItem::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

.requiredItem::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

.requiredItem:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

.requiredItem:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="date"]:focus,
select.form-control:focus,
textarea.form-control:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"].requiredItem:focus,
input[type="email"].requiredItem:focus,
input[type="search"].requiredItem:focus,
input[type="number"].requiredItem:focus,
input[type="password"].requiredItem:focus,
input[type="tel"].requiredItem:focus,
input[type="date"].requiredItem:focus,
select.form-control.requiredItem:focus,
textarea.form-control.requiredItem:focus,
textarea.requiredItem:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border-bottom: 1px solid #dc858b;
}

input[type="text"]:hover,
input[type="email"]:hover,
input[type="search"]:hover,
input[type="number"]:hover,
input[type="password"]:hover,
input[type="tel"]:hover,
input[type="date"]:hover,
select.form-control:hover,
textarea.form-control:hover {
  box-shadow: none;
  background: #fff;
  outline: none !important;
}

input[type="text"].requiredItem:hover,
input[type="email"].requiredItem:hover,
input[type="search"].requiredItem:hover,
input[type="number"].requiredItem:hover,
input[type="password"].requiredItem:hover,
input[type="tel"].requiredItem:hover,
input[type="date"].requiredItem:hover,
select.form-control.requiredItem:hover,
textarea.form-control.requiredItem:hover {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"]:hover::-webkit-input-placeholder,
input[type="email"]:hover::-webkit-input-placeholder,
input[type="search"]:hover::-webkit-input-placeholder,
input[type="number"]:hover::-webkit-input-placeholder,
input[type="password"]:hover::-webkit-input-placeholder,
input[type="tel"]:hover::-webkit-input-placeholder,
input[type="date"]:hover::-webkit-input-placeholder,
select.form-control:hover::-webkit-input-placeholder,
textarea.form-control:hover::-webkit-input-placeholder,
textarea:hover::-webkit-input-placeholder,
input[type="text"]:focus::-webkit-input-placeholder,
input[type="email"]:focus::-webkit-input-placeholder,
input[type="search"]:focus::-webkit-input-placeholder,
input[type="number"]:focus::-webkit-input-placeholder,
input[type="password"]:focus::-webkit-input-placeholder,
input[type="tel"]:focus::-webkit-input-placeholder,
input[type="date"]:focus::-webkit-input-placeholder,
select.form-control:focus::-webkit-input-placeholder,
textarea.form-control:focus::-webkit-input-placeholder,
textarea:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-webkit-input-placeholder,
input[type="email"].requiredItem:hover::-webkit-input-placeholder,
input[type="search"].requiredItem:hover::-webkit-input-placeholder,
input[type="number"].requiredItem:hover::-webkit-input-placeholder,
input[type="password"].requiredItem:hover::-webkit-input-placeholder,
input[type="tel"].requiredItem:hover::-webkit-input-placeholder,
input[type="date"].requiredItem:hover::-webkit-input-placeholder,
select.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.requiredItem:hover::-webkit-input-placeholder,
input[type="text"].requiredItem:focus::-webkit-input-placeholder,
input[type="email"].requiredItem:focus::-webkit-input-placeholder,
input[type="search"].requiredItem:focus::-webkit-input-placeholder,
input[type="number"].requiredItem:focus::-webkit-input-placeholder,
input[type="password"].requiredItem:focus::-webkit-input-placeholder,
input[type="tel"].requiredItem:focus::-webkit-input-placeholder,
input[type="date"].requiredItem:focus::-webkit-input-placeholder,
select.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.requiredItem:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

input[type="text"]:hover::-moz-placeholder,
input[type="email"]:hover::-moz-placeholder,
input[type="search"]:hover::-moz-placeholder,
input[type="number"]:hover::-moz-placeholder,
input[type="password"]:hover::-moz-placeholder,
input[type="tel"]:hover::-moz-placeholder,
input[type="date"]:hover::-moz-placeholder,
select.form-control:hover::-moz-placeholder,
textarea:hover::-moz-placeholder,
textarea.form-control:hover::-moz-placeholder,
input[type="text"]:focus::-moz-placeholder,
input[type="email"]:focus::-moz-placeholder,
input[type="search"]:focus::-moz-placeholder,
input[type="number"]:focus::-moz-placeholder,
input[type="password"]:focus::-moz-placeholder,
input[type="tel"]:focus::-moz-placeholder,
input[type="date"]:focus::-moz-placeholder,
select.form-control:focus::-moz-placeholder,
textarea.form-control:focus::-moz-placeholder,
textarea:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-moz-placeholder,
input[type="email"].requiredItem:hover::-moz-placeholder,
input[type="search"].requiredItem:hover::-moz-placeholder,
input[type="number"].requiredItem:hover::-moz-placeholder,
input[type="password"].requiredItem:hover::-moz-placeholder,
input[type="tel"].requiredItem:hover::-moz-placeholder,
input[type="date"].requiredItem:hover::-moz-placeholder,
select.form-control.requiredItem:hover::-moz-placeholder,
textarea.form-control.requiredItem:hover::-moz-placeholder,
input[type="text"].requiredItem:focus::-moz-placeholder,
input[type="email"].requiredItem:focus::-moz-placeholder,
input[type="search"].requiredItem:focus::-moz-placeholder,
input[type="number"].requiredItem:focus::-moz-placeholder,
input[type="password"].requiredItem:focus::-moz-placeholder,
input[type="tel"].requiredItem:focus::-moz-placeholder,
input[type="date"].requiredItem:focus::-moz-placeholder,
select.form-control.requiredItem:focus::-moz-placeholder,
textarea.form-control.requiredItem:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-ms-input-placeholder,
input[type="email"]:hover:-ms-input-placeholder,
input[type="search"]:hover:-ms-input-placeholder,
input[type="number"]:hover:-ms-input-placeholder,
input[type="password"]:hover:-ms-input-placeholder,
input[type="tel"]:hover:-ms-input-placeholder,
input[type="date"]:hover:-ms-input-placeholder,
select.form-control:hover:-ms-input-placeholder,
textarea.form-control:hover:-ms-input-placeholder,
input[type="text"]:focus:-ms-input-placeholder,
input[type="email"]:focus:-ms-input-placeholder,
input[type="search"]:focus:-ms-input-placeholder,
input[type="number"]:focus:-ms-input-placeholder,
input[type="password"]:focus:-ms-input-placeholder,
input[type="tel"]:focus:-ms-input-placeholder,
input[type="date"]:focus:-ms-input-placeholder,
select.form-control:focus:-ms-input-placeholder,
textarea.form-control:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-ms-input-placeholder,
input[type="email"].requiredItem:hover:-ms-input-placeholder,
input[type="search"].requiredItem:hover:-ms-input-placeholder,
input[type="number"].requiredItem:hover:-ms-input-placeholder,
input[type="password"].requiredItem:hover:-ms-input-placeholder,
input[type="tel"].requiredItem:hover:-ms-input-placeholder,
input[type="date"].requiredItem:hover:-ms-input-placeholder,
select.form-control.requiredItem:hover:-ms-input-placeholder,
textarea.form-control.requiredItem:hover:-ms-input-placeholder,
input[type="text"].requiredItem:focus:-ms-input-placeholder,
input[type="email"].requiredItem:focus:-ms-input-placeholder,
input[type="search"].requiredItem:focus:-ms-input-placeholder,
input[type="number"].requiredItem:focus:-ms-input-placeholder,
input[type="password"].requiredItem:focus:-ms-input-placeholder,
input[type="tel"].requiredItem:focus:-ms-input-placeholder,
input[type="date"].requiredItem:focus:-ms-input-placeholder,
select.form-control.requiredItem:focus:-ms-input-placeholder,
textarea.form-control.requiredItem:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-moz-placeholder,
input[type="email"]:hover:-moz-placeholder,
input[type="search"]:hover:-moz-placeholder,
input[type="number"]:hover:-moz-placeholder,
input[type="password"]:hover:-moz-placeholder,
input[type="tel"]:hover:-moz-placeholder,
input[type="date"]:hover:-moz-placeholder,
select.form-control:hover:-moz-placeholder,
textarea.form-control:hover:-moz-placeholder,
input[type="text"]:focus:-moz-placeholder,
input[type="email"]:focus:-moz-placeholder,
input[type="search"]:focus:-moz-placeholder,
input[type="number"]:focus:-moz-placeholder,
input[type="password"]:focus:-moz-placeholder,
input[type="tel"]:focus:-moz-placeholder,
input[type="date"]:focus:-moz-placeholder,
select.form-control:focus:-moz-placeholder,
textarea.form-control:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-moz-placeholder,
input[type="email"].requiredItem:hover:-moz-placeholder,
input[type="search"].requiredItem:hover:-moz-placeholder,
input[type="number"].requiredItem:hover:-moz-placeholder,
input[type="password"].requiredItem:hover:-moz-placeholder,
input[type="tel"].requiredItem:hover:-moz-placeholder,
input[type="date"].requiredItem:hover:-moz-placeholder,
select.form-control.requiredItem:hover:-moz-placeholder,
textarea.form-control.requiredItem:hover:-moz-placeholder,
input[type="text"].requiredItem:focus:-moz-placeholder,
input[type="email"].requiredItem:focus:-moz-placeholder,
input[type="search"].requiredItem:focus:-moz-placeholder,
input[type="number"].requiredItem:focus:-moz-placeholder,
input[type="password"].requiredItem:focus:-moz-placeholder,
input[type="tel"].requiredItem:focus:-moz-placeholder,
input[type="date"].requiredItem:focus:-moz-placeholder,
select.form-control.requiredItem:focus:-moz-placeholder,
textarea.form-control.requiredItem:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS Starts here */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 0;
  color: #6a6a6a;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  border: 1px solid #1dd8f6;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: #1dd8f6;
  border: 1px solid #1dd8f6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #6a6a6a;
  padding: 0;
  text-decoration: none;
}

.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  background: #f2fdff;
}

.menuItemsWrapper {
  border-right: 1px solid #e5f0f2;
  padding-right: 40px !important;
  margin-right: 40px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  padding-left: 40px;
  position: relative;
  color: #6a6a6a;
}

.menuItem > a {
  color: #6a6a6a;
  text-decoration: none;
}

.menuItem:hover,
.menuItem.active {
  color: #1dd8f6;
  cursor: pointer;
}

.menuItem:hover > a,
.menuItem.active > a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.menuItem:after,
.menuItem:after {
  content: "";
  background: #f27778;
  height: 3px;
  width: 0;
  position: absolute;
  top: 49px;
  transition: 0.5s;
  opacity: 0;
}

.menuItem:hover:after,
.menuItem.active:after {
  width: calc(100% - 40px);
  opacity: 1;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics > span {
  position: relative;
  top: -1px;
  color: #6a6a6a;
  font-size: 19px;
  line-height: 1;
}

.dashboardBlocksWrapper {
  padding: 30px 15px;
  background: #f2fdff;
  border-bottom: 1px solid #e5f0f2;
}

.dashboardBlock {
  background: red;
  margin: 0 15px;
  padding: 30px;
  border-radius: 10px;
}

.dashboardIcon {
  float: left;
  margin-right: 20px;
}

.dashboardNumber {
  float: left;
  font-size: 45px;
  color: #fff;
  line-height: 1;
}

.dashboardNumber > span {
  font-size: 16px;
  display: block;
}

.dashboardBlock:first-child {
  background: rgb(0, 192, 255);
  background: linear-gradient(45deg,
    rgba(0, 192, 255, 1) 0%,
    rgba(0, 192, 255, 1) 35%,
    rgba(26, 102, 168, 1) 100%);
}

.dashboardBlock:nth-child(2) {
  background: rgb(0, 255, 169);
  background: linear-gradient(45deg,
    rgba(0, 255, 169, 1) 0%,
    rgba(13, 77, 255, 1) 100%);
}

.dashboardBlock:nth-child(3) {
  background: rgb(31, 201, 253);
  background: linear-gradient(45deg,
    rgba(31, 201, 253, 1) 0%,
    rgba(252, 0, 97, 1) 100%);
}

.dashboardBlock:nth-child(4) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
    rgba(163, 44, 223, 1) 0%,
    rgba(138, 54, 220, 1) 33%,
    rgba(77, 79, 215, 1) 66%,
    rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:nth-child(5) {
  background: rgb(0, 255, 255);
  background: linear-gradient(45deg,
    rgba(0, 255, 255, 1) 0%,
    rgba(147, 39, 143, 1) 100%);
}

.dashboardBlock:nth-child(6) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
    rgba(163, 44, 223, 1) 0%,
    rgba(138, 54, 220, 1) 33%,
    rgba(77, 79, 215, 1) 66%,
    rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:last-child {
  background: rgb(254, 193, 148);
  background: linear-gradient(45deg,
    rgba(254, 193, 148, 1) 0%,
    rgba(254, 168, 141, 1) 30%,
    rgba(254, 107, 125, 1) 50%,
    rgba(254, 8, 99, 1) 70%,
    rgba(255, 0, 97, 1) 100%);
}

.facilityInfoWrapper {
  overflow: auto;
  max-height: calc(100vh - 262px);
}

.facilityInfoRow {
  padding: 30px 15px 0 15px;
  background: #fff;
  width: 100%;
}

.facilityInfo {
  color: #6a6a6a;
  font-size: 14px;
  margin: 0 15px 30px 15px;
  border: 1px solid #e5f0f2;
  border-radius: 10px;
  padding: 0;
  max-width: calc((100vw / 7) - 35px);
  width: calc((100vw / 7) - 35px);
}

.facilityInfo .dashboardNumber {
  color: #1a80a8;
  padding: 0 25px;
  font-size: 55px;
}

.facilityName {
  background: #f2fdff;
  color: #1dd8f6;
  font-size: 16px;
  text-align: center;
  padding: 10px 5px;
  border-radius: 0 0 10px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.infoWrapper {
  padding: 10px 20px;
  border-left: 1px solid #e5f0f2;
}

.infoItem {
  display: flex;
  line-height: 20px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  min-width: 360px;
  max-width: 360px;
  border-radius: 5px;
  margin-left: 10px;
  align-items: center;
  text-overflow: ellipsis;
}


.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background: transparent !important;
}

.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #00b5da;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  color: #fff;
  padding: 0 15px;
  height: 40px;
}

.popupHead span {
  float: right;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #f2fdff;
  color: #6a6a6a;
  padding: 15px;
  justify-content: center;
  text-align: center;
}

.yesBtn,
.noBtn {
  margin-right: 15px;
  border: 1px solid #dae1f2 !important;
  border-radius: 10px;
  padding: 5px 20px !important;
}

.noBtn {
  margin-left: 15px;
  margin-right: 0px;
}

.yesBtn:hover,
.noBtn:hover {
  background: #fff !important;
  color: #00b5da !important;
}

.modal-header {
  background: #50b9d4;
  color: #fff;
}

.modal-title {
  font-size: 14px !important;
}

.modal-body {
  color: #7b7b7b;
}

.modal-footer {
  background: #f2fdff;
  color: #1a80a8;
  justify-content: center;
}

.modal-footer .btn {
  padding: 5px 20px;
  border-radius: 6px;
  min-width: 100px;
  //border: 1px solid #50B9D4 !important;
}

.modal-footer .btn:hover {
  background: #fff;
  color: #50b9d4;
  cursor: pointer;
}

.modal-footer > :not(:last-child) {
  margin-right: 15px;
}

.modal-footer > :not(:first-child) {
  margin-left: 15px;
}

.filter-wrapper-2 {
  max-width: 400px;
  min-height: 36px;
}

.filterText {
  color: #fff;
  opacity: 1;
  padding-right: 5px;
}

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent !important;
  height: auto;
}

.filterDropDown {
  color: #fff;
  opacity: 1;
  text-decoration: none;
  width: 100%;
  display: inline-block;
}

.filterDropDown:after {
  float: right;
  position: relative;
  top: 10px;
}

.filterDropDown:hover {
  text-decoration: none;
}

.filterDropDownData,
.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

.actionDropDownData {
  top: 10px !important;
}

.filterDropDownData > a,
.actionDropDownData > a {
  color: #6a6a6a;
  text-decoration: none;
  padding: 5px 15px;
  position: relative;
}

.filterDropDownData > a:hover,
.filterDropDownData > a.active,
.actionDropDownData > a:hover,
.actionDropDownData > a.active {
  text-decoration: none;
  background: #f2fdff;
  color: #1dd8f6;
}

.filterDropDownData > a::after,
.actionDropDownData > a::after {
  content: "";
  height: 1px;
  width: 70%;
  left: 15%;
  position: absolute;
  bottom: 0;
  background: #daf9ff;
}

.filterDropDownData > a:last-child::after,
.filterDropDownData > a.active::after,
.filterDropDownData > a:hover:after,
.actionDropDownData > a:last-child::after,
.actionDropDownData > a.active::after,
.actionDropDownData > a:hover:after {
  display: none;
}

.pageDataWrapper {
  padding: 20px;
}

.tableDataWrapper {
}

.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}

.contentHeader td {
  padding: 0 15px;
}

.contentRow > td {
  border-bottom: 1px solid #daf9ff;
  align-items: center;
  padding: 0 15px;
  background: #fff !important;
  color: #6a6a6a;
  cursor: pointer;
}

.contentRow.error td {
  background: #f16161 !important;
  color: #fff;
}

.contentRow.active td {
  background-color: #f4fbfe !important;
}

.contentRow:hover td {
  background-color: #f4fbfe !important;
}

.contentRow.error:hover td {
  background-color: #f57676 !important;
}

.contentDataWrapper {
  overflow: auto;
  overflow-y: auto;
  max-height: calc(100vh - 270px);
  min-height: calc(100vh - 270px);
  align-content: flex-start;
  padding-right:5px;
}

.contentRow {
  height: 50px;
}

.contentData {
  background: #fff;
  color: #6a6a6a;
  height: auto;
  margin-top: 10px !important;
  cursor: pointer;
  min-height: 48px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData > div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}

.contentData > div:first-child {
  border-left: 0px solid;
}

.devicesPageHeader {
  padding-left: 0;
}

.deviceStatus {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  background: #66be6d;
}

.deviceStatus.offlineDevices {
  background: #f27778;
}

.deviceStatus.totalDevices {
  background: #3188D2;
}

.devicesPageHeader .filterWrapper {
  max-width: 200px;
  min-width: 200px;
}

.actionDropDown {
  background: #50b9d4;
  border-radius: 20px;
  color: #fff;
  float: right;
  padding: 5px 25px;
  width: 140px;
  text-align: left;
}

.actionDropDown:after {
  right: 30px;
  position: absolute;
  top: 15px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.contentData > div .actionDropDown {
  background: transparent;
  border: 1px solid #dedede;
  color: #6a6a6a;
}

.deviceName {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 5px !important;
  margin-bottom: 5px;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.deviceName > span {
  color: #1dd8f6;
  padding-right: 15px;
}

.deviceDataWrapper .contentData {
  height: 80px;
}

.deviceDataWrapper .contentData > div:last-child {
  display: inline-flex;
  overflow: unset;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
  width: auto;
  line-height: 36px;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background:#3288D2;
}

.hasNotifications {
  max-width: 160px;
}

.selectArea {
  max-width: 130px;
}

.userContentWrapper .contentData > div:first-child,
.userContentWrapper .contentData > div:nth-child(2) {
  display: flex;
}

.userContentWrapper .contentData > div span {
  color: #6a6a6a;
  padding-right: 5px;
}
.userContentWrapper .contentData > div label{
  color:#6a6a6a;
}

.btn {
  background: #1dd8f6;

  color: #fff;
  // position:absolute;
  // top:250px;
  // left:500px;
  border-color: #1dd8f6;
  padding: 5px 10px;
  border: 0px;
}

.userDetailContentHeader {
  background: #ebebeb;
  color: #484848;
  font-size: 15px;
  padding: 15px 0;
  border-radius: 5px;
}
.userDetailContentHeader .filter-wrapper-2{
  height:36px;
  min-width:278px;
  padding:0 10px;
}

.userDetailContentHeader > div {
  display: inline-flex;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}

.buttonItem.disabled,
.buttonItem[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

a.buttonItem.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}

.buttonItem:hover {
  background: #3188D2;
  color: #fff;
  border:1px solid #3288D2;
}

.buttonItem img {
  margin-left: 15px;
}

.detailWrapper {
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #a6e3f0;
  margin-top: 30px !important;
  max-height: calc(100vh - 300px);
  overflow: hidden;
  overflow-y: auto;
  min-height: 100px;
}

.userDemograpics {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #dceaea;
}

.h-100 {
  overflow-x: hidden;
}

.labelText {
  color: #1dd8f6;
}

.userDetails {
  width: 100%;
}

.userDetails .col:first-child {
  border-right: 1px solid #fdf7f7;
  padding-right: 20px;
}

.userDetails .col:last-child {
  padding-left: 20px;
}

.addBtn {
  border: 1px solid #dceaea !important;
  border-radius: 5px;
  padding: 7px 15px !important;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
  cursor: pointer;
}

.selectListItems {
  width: calc(100% - 120px);
  margin-right: 30px;
}

.selectedItem {
  color: #6a6a6a;
  margin-top: 30px;
}

.selectedItem > img {
  margin-right: 15px;
}

.clearSelectedItems {
  color: #f27778;
  text-decoration: underline;
  padding-top: 30px;
  width: 67px;
  cursor: pointer;
}

::v-deep .ui.selection.dropdown .menu .item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 334px;
}

.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

@media (max-width: 1919px) {
  .dashboardBlock {
    padding: 15px;
  }

  .dashboardIcon {
    margin-right: 10px;
  }

  .dashboardIcon > img {
    width: 22px;
  }

  .dashboardNumber {
    font-size: 36px;
  }

  .dashboardNumber > span {
    font-size: 12px;
    display: block;
  }

  .facilityInfo .dashboardNumber {
    padding: 0 13px;
    font-size: 36px;
  }

  .facilityName {
    font-size: 14px;
  }

  .infoWrapper {
    padding: 10px;
  }

  .facilityInfoWrapper {
    overflow: auto;
    max-height: calc(100vh - 220px);
  }

  .pageHeader {
    font-size: 20px;
  }

  .actionDropDown {
    width: 125px;
  }

  .userContentWrapper .contentData > div:nth-child(2) .text-right {
    text-align: left !important;
  }

  .filterInputText {
    max-width: 215px !important;
    background: rgba(255, 255, 255, 0.5) !important;
    color: #fff !important;
    padding: 0 0 0 4px !important;
  }
}

.filterInputText {
  max-width: 215px !important;
  background: #575757 !important;
  outline: none !important;
  border: 1px solid #575757 !important;
  //background: rgba(255,255,255,0.5) !important;
  color: #fff !important;
  padding: 1px 15px;
  padding-left: 0 !important;
}

#tenantConnectionId option {
  color: #6a6a6a;
}

.subHeadWrap {
  line-height: 35px;
  padding: 0 32px 0px 5px;
}

body select {
  /*width: 100px !important;*/
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  outline: none;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  // background: rgba(0, 0, 0, 0.3);
  color: #6a6a6a;
}

.v-toast__item .toast-bgclass {
  background-color: #f16161 !important;
}

.contacts {
  overflow: hidden;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .ui.search.dropdown .text {
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;
  height: 15px;
}
.contentInfo{
  color:#1a8088;
  margin:20px
}

</style>
